import React from "react";
import { connect } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import Select from "react-select";
import CommonIcon from "../../helpers/icons";
import Chart from "react-apexcharts";
import API from "../../helpers/endpointservice";
import Pagination from "react-js-pagination";
import Toaster from "../../helpers/toaster";
import StarRatings from "react-star-ratings";
import axios from "axios";
import LoaderVisible from "../../helpers/loader";
import { colors } from "../../helpers/Constants";
import chroma from "chroma-js";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";
import CommonFilterModal from "../common/commonFilterModal";
import InfoIcon from "@mui/icons-material/Info";
import SkillChart from "./CapabilitySummaryChart";
import { DeblurOutlined } from "@mui/icons-material";
import { tr } from "date-fns/locale";
import SkillBar from "./SkillBar";

const colorStyles = {
    control: (styles) => ({ ...styles, backgroundColor: "white" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma(data.color);
        return {
            ...styles,
            backgroundColor: isDisabled
                ? null
                : isSelected
                    ? data.color
                    : isFocused
                        ? color.alpha(0.1).css()
                        : null,
            color: isDisabled
                ? "#ccc"
                : isSelected
                    ? chroma.contrast(color, "white") > 2
                        ? "white"
                        : "black"
                    : data.color,
            cursor: isDisabled ? "not-allowed" : "default",

            ":active": {
                ...styles[":active"],
                backgroundColor:
                    !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
            },
        };
    },
    // input: styles => ({ ...styles, ...dot() }),
    // placeholder: styles => ({ ...styles, ...dot() }),
    // singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) })
};

const newColors = [
    {
        label: "Master",
        value: "45,Master",
        color: "#21a366",
    },
    {
        label: "Competent",
        value: "46,Competent",
        color: "#4c4bfe",
    },
    {
        label: "Learner",
        value: "47,Learner",
        color: "#EC930D",
    },
    {
        label: "Novice",
        value: "50,Novice",
        color: "#EAD51A",
    },
    {
        label: "NA",
        value: "48,NA",
        color: "#A52A2A",
    },
];

class CompetencyGrading extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            capabilitySummaryData: [],
            order: localStorage.getItem("Role").split(",").includes("manager")
                ? ""
                : "asc",
            sortBy: localStorage.getItem("Role").split(",").includes("manager")
                ? ""
                : "employeeCode",
            sortBy1: "jobGroup",
            order1: "asc",
            sortBy2: "jobGroup",
            order2: "asc",
            options: {
                dataLabels: {
                    enabled: true,
                    formatter: function (val, option) {
                        if (option?.w?.globals?.initialSeries?.length == 6) {
                        } else {
                            return val.toFixed(2) + "%";
                        }
                    },
                },
                legend: false,
                labels: [
                    "Master",
                    "Competent",
                    "Learner",
                    "Novice",
                    "NA",
                    "No records",
                ],
                // labels: [],
                colors: [
                    colors.GREEN,
                    colors.BLUE,
                    colors.ORANGE,
                    colors.YELLOW,
                    colors.BROWN,
                    colors.GREY,
                ],
                // colors: [
                //   // colors.GREEN,
                //   // colors.BLUE,
                //   // colors.ORANGE,
                //   // colors.YELLOW,
                //   // colors.BROWN,
                // ],
                stroke: {
                    width: 0,
                },
                tooltip: {
                    enabled: true,
                    shared: false,
                },
                plotOptions: {
                    pie: {
                        expandOnClick: false,
                    },
                },
                isSearchApplied: false,
            },

            series: {
                master: 0,
                competent: 0,
                learning: 0,
                novice: 0,
                na: 0,
            },
            proficiencyNameEditShow: "",
            isMobile: false,
            isMobile450: false,
            isMobile350: false,
            isSkillMatrix: false,
            isMobile650: false,
            isMobile900: false,
            mainUserId: 0,
            UserId: "",
            currentUser: "",
            heading: "",
            height: 0,
            width: 0,
            perPage: 20,
            currentPage: 1,
            // pageNewCount: false,
            proficiencyList: [],
            isMaster: false,
            isLearning: false,
            isNa: false,
            isCompetent: false,
            isNovice: false,
            skillMatrixList: [],
            auditLog: [],
            supportingRolesList: [],
            myTeamList: [],
            searchData: {},
            employeeCode: "",
            // employeeName: "",
            designation: "",
            email: "",
            phoneNumber: "",
            isSearch: false,
            employeeList: [],
            currentStatus: [],
            statuslist: [],
            selectEmployeeName: [],
            selectedStatus: [],
            searchInputData: {
                employeeCode: "",
                employeeName: "",
                designation: "",
                email: "",
                phoneNumber: "",
                supervisor: "",
                status: "",
                department: ""
            },
            proficiencyError: false,
            graphDataValue: false,
            validationMsg: false,
            mainRoleBorder: true,
            supportroleBorder: false,
            mainRoleCount: 0,
            supportRoleCount: 0,
            isMainRole: true,
            isSupportRole: false,
            totalCount: 20,
            pageCountCr: 20,
            pageCountMr: 20,
            pageCount: 20,
            currentPageCr: 1,
            currentPageMr: 1,
            perPageCr: 20,
            perPageMr: 20,
            paginListMainRole: [{ label: "20", value: 20 }],
            pagingListCommitteeRole: [{ label: "20", value: 20 }],
            pagingListValue: [{ label: "20", value: 20 }],
            employeeCode: "",
            employeeName: "",
            mainRoleName: "",
            designationName: "",
            committeeRoleName: "",
            isSkillDateRange: true,
            isMainRoleChanged: false,
            isCommitteeroleChanged: false,
            searchMainSupportRoles: {
                job: "",
                jobGroup: "",
                skillId: 0,
                skill: "",
                level: "",
                proficiency: "",
                proficiencyId: 0,
                levelId: 0,
                proficiencyExpectedId: 0,
                proficiencyExpected: "",
                courseProvider: "",
            },
            isLevelValidate: true,
            isdateValidate: true,
            levelMessage: "",
            dateMessage: "",
            iserrortoastVisible: false,
            iserrordatetoastVisible: false,
            isCapabilitySummary: false,
            isDirect2: false,
            selectedDepartmentId: null,
            selectedProficiencyId: [],
            searchScreen1: false,
            searchScreen: false,
            legendItems: [
                { label: "Master", color: "#28A745" },
                { label: "Competent", color: "#508FD6" },
                { label: "Learner", color: "#EC930D" },
                { label: "Novice", color: "#EAD51A" },
            ],
        };
    }
    componentDidMount() {
        let user = localStorage.getItem("UserId");
        let value = localStorage.getItem("Role").split(",")[0];
        this.state.UserId = user;
        this.state.currentUser = value;
        this.setState({
            isSkillMatrix: false,
            mainRoleBorder: true,
            isMainRole: false,
            isSupportRole: false,
            supportroleBorder: false,
            employeeCode: "",
            employeeName: "",
            isMainRoleChanged: false,
            isCommitteeroleChanged: false,
            proficiencyError: false,
        });
        // this.setState({});
        // this.getCapabilitySummary();
        this.getTeamList(this.state.currentPage, this.state.perPage);
        window.addEventListener("resize", this.resize);
        this.resize(); // Initial call to set state

        $("body").removeClass("scrollhide");
        this.getProficiencyList();
        this.getEmployeeList();
        this.getcurrentStatus();
        this.getDepartmentDropDown();
        this.getEmployeeName();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }
    getcurrentStatus = () => {
        let apiUrl = `${API.GET_CURRENT_STATUS}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.currentStatus = res?.data?.teamCapabilityStatus?.map(
                        (status) => {
                            return {
                                value: status,
                                label: (
                                    <>
                                        <span>{status}</span>
                                    </>
                                ),
                            };
                        }
                    );
                    // this.setState({});
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ loader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    getEmployeeList = () => {
        let apiUrl = `${API.GET_EMPLOYEES}?userId=${this.state.UserId}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.employeeList = res?.data?.map((employee) => {
                        return {
                            value: employee.employeeId + "," + employee.employeeName,
                            label: (
                                <>
                                    <span>{employee.employeeName}</span>
                                </>
                            ),
                        };
                    });
                    // this.setState({});
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ loader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    getProficiencyList = () => {
        let apiUrl = `${API.GET_PROFICIENCY}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.skills = res?.data;
                    this.state.proficiencyList = res?.data?.map((proficiency) => {
                        return {
                            value: proficiency.id,
                            label: (
                                <>
                                    <span>{proficiency.name}</span>
                                </>
                            ),
                        };
                    });
                }
                let name = [];
                let color = [];
                res?.data?.map((item) => {
                    name.push(item?.name);
                    color.push(item?.color);
                });
                this.setState({ labels: name, colors: color });
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ loader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    handleVendorName = (e) => {
        this.setState({
            ...this.state.skillMatrixList,
            proficiencyId: e,
        });
    };

    proficiency = (e, id) => {
        this.state.supportingRolesList[id].proficiency = e.target.value;
        // this.setState({});
    };

    proficiency1 = (e, id) => {
        this.state.skillMatrixList[id].proficiency = e.target.value;
        this.setState({});
    };

    changeCapabilitytabs = () => {
        this.setState(
            {
                myTeamList: [],
                searchInputData: {
                    employeeCode: "",
                    employeeName: "",
                    designation: "",
                    email: "",
                    phoneNumber: "",
                    supervisor: "",
                    status: "",
                    department: ""
                },
                selectEmployeeName: [],
                selectedStatus: [],
                currentPage: 1,
                perPage: 20,
            },
            () => {
                this.getTeamList(this.state.currentPage, this.state.perPage);
            }
        );
    };

    getTeamList = (currentPage, perPage) => {
        const { isSearch, searchInputData, isDirect2 } = this.state;
        this.setState({ loader: true });
        let apiUrl = `${API.GET_ALL_MEMBERS_CHART}?userId=${this.state.UserId
            }&sortBy=${this.state.sortBy}&isSortAscending=${this.state.order == "asc" ? true : this.state.order == "desc" ? false : ""
            }&pageNumber=${currentPage}&pageSize=${perPage}`;
        let searchData = {
            employeeName: this.state.selectEmployeeName?.value || null,
            employeeCode: searchInputData.employeeCode || null,
            designation: searchInputData.designation || null,
            email: searchInputData.email || null,
            mobileNumber: searchInputData.phoneNumber || null,
            status: this.state.selectedStatus?.value || null,
            supervisor: searchInputData.supervisor || null,
            department: searchInputData.department?.value || null,
        };
        axios({
            method: "POST",
            url: apiUrl,
            data: isSearch === true ? searchData : {},
        })
            .then((res) => {
                if (res.status === 200) {
                    this.setState({
                        myTeamList: res.data.values,
                        totalCount: res.data.totalCount,
                        pageCount: res.data.totalCount,
                    });
                    this.setState({ loader: false });
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loader: false, isSearch: false });
                logoutFunction(error?.response?.status);
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    getCapabilitySummary = () => {
        if (
            this.state.selectedDepartmentId != null &&
            this.state.selectedDepartmentId != undefined &&
            this.state.selectedDepartmentId?.id != 0 &&
            this.state.selectedDepartmentId != 0 &&
            this.state.selectedDepartmentId?.id != ""
        ) {
            let role = localStorage.getItem("Role").split(",").includes("admin");
            let apiUrl;
            if (role == true) {
                apiUrl = `${API.GET_CAPABILITY_SUMMARY}?departmentId=${this.state.selectedDepartmentId?.id}`;
            } else {
                apiUrl = `${API.GET_CAPABILITY_SUMMARY}?userId=${this.state.UserId}&departmentId=${this.state.selectedDepartmentId?.id}`;
            }
            // let apiUrl = `${API.GET_CAPABILITY_SUMMARY}?userId=${this.state.UserId}&departmentId=${this.state.selectedDepartmentId?.id}`;
            const ids = this.state.selectedProficiencyId.map((opt) => opt.value);
            let payload = ids ? ids : [];
            this.setState({ loader: true });
            axios({
                method: "POST",
                url: apiUrl,
                data: payload,
            })
                .then((res) => {
                    if (res.data) {
                        this.setState({ capabilitySummaryData: res.data });
                        this.setState({ loader: false });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ capabilitySummaryData: [] });
                    this.setState({ loader: false });
                });
        }
    };

    getGraphValue = async () => {
        // this.setState({ loader: true });
        let getGraphApiUrl = `${API.GET_SKILL_OVERVIEW}?userId=${this.state.heading}`;
        // let getGraphApiUrl = `${API.GET_SKILL_OVERVIEW}?userId=${this.state.UserId}`;
        await axios
            .get(getGraphApiUrl)
            .then((response) => {
                if (response?.status === 200) {
                    if (
                        response.data.master > 0 ||
                        response.data.competent > 0 ||
                        response.data.novice > 0 ||
                        response.data.na > 0 ||
                        response.data.learning > 0
                    ) {
                        this.setState({
                            graphDataValue: true,
                        });
                    } else {
                        this.setState({ graphDataValue: false });
                    }
                    let graphData = {
                        ...this.state.series,
                        master: response.data?.master,
                        competent: response.data?.competent,
                        learning: response.data?.learning,
                        novice: response.data?.novice,
                        na: response.data?.na,
                        masterProficiencyDescription:
                            response.data?.masterProficiencyDescription,
                        competentProficiencyDescription:
                            response.data?.competentProficiencyDescription,
                        learningProficiencyDescription:
                            response.data?.learningProficiencyDescription,
                        noviceProficiencyDescription:
                            response.data?.noviceProficiencyDescription,
                        naProficiencyDescription: response.data?.naProficiencyDescription,
                    };

                    this.setState({
                        loader: false,
                        series: graphData,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ loader: false });
                logoutFunction(err?.response?.status);
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    resize = () => {
        console.log("called here");

        if (window.innerWidth < 850) {
            this.state.isMobile = true;
        } else {
            this.state.isMobile = false;
        }

        if (window.innerWidth < 900) {
            this.state.isMobile900 = true;
        } else {
            this.state.isMobile900 = false;
        }

        if (window.innerWidth < 350) {
            this.state.isMobile350 = true;
        } else {
            this.state.isMobile350 = false;
        }

        if (window.innerWidth < 650) {
            this.state.isMobile650 = true;
        } else {
            this.state.isMobile650 = false;
        }

        if (window.innerWidth < 450) {
            this.state.isMobile450 = true;
        } else {
            this.state.isMobile450 = false;
        }
        this.state.height = window.innerHeight;
        this.state.width = window.innerWidth;
        this.setState({});
    };

    closeProperties = () => {
        $("body").removeClass("scrollhide");
    };

    sortTable = (name) => {
        let sortData = this.state.myTeamList;
        if (sortData && sortData.length !== 0) {
            if (this.state.sortBy === name) {
                this.state.sortBy = name;
                if (this.state.order === "asc") {
                    var ordernew = "desc";
                    this.state.order = ordernew;
                } else {
                    var ordernew = "asc";
                    this.state.order = ordernew;
                }
            } else {
                this.state.sortBy = name;
                this.state.order = "asc";
            }
            this.setState({
                currentPage: 1,
                // pageNewCount : !this.state.pageNewCount
            });
            this.getTeamList((this.state.currentPage = 1), this.state.perPage);
        }
    };

    sortTable1 = (name) => {
        let sortData1 = this.state.skillMatrixList;
        this.setState({
            isCommitteeroleChanged: false,
            isMainRoleChanged: false,
            proficiencyError: false,
        });
        if (sortData1 && sortData1.length !== 0) {
            if (this.state.sortBy1 === name) {
                this.state.sortBy1 = name;
                if (this.state.order1 === "asc") {
                    var ordernew1 = "desc";
                    this.state.order1 = ordernew1;
                } else {
                    var ordernew1 = "asc";
                    this.state.order1 = ordernew1;
                }
            } else {
                this.state.sortBy1 = name;
                this.state.order1 = "asc";
            }
            this.setState({});
            this.handleSkillMatrixPage(
                this.state.mainUserId,
                1,
                this.state.perPageMr,
                this.state.employeeName,
                this.state.employeeCode,
                this.state.sortBy1,
                this.state.searchMainSupportRoles,
                false
            );
        }
    };

    sortTable2 = (name) => {
        let sortData2 = this.state.supportingRolesList;
        if (sortData2 && sortData2.length !== 0) {
            if (this.state.sortBy2 === name) {
                this.state.sortBy2 = name;
                if (this.state.order2 === "asc") {
                    var ordernew2 = "desc";
                    this.state.order2 = ordernew2;
                } else {
                    var ordernew2 = "asc";
                    this.state.order2 = ordernew2;
                }
            } else {
                this.state.sortBy2 = name;
                this.state.order2 = "asc";
            }
            this.setState({});
            this.handleSkillMatrixPage1(
                this.state.mainUserId,
                (this.state.currentPageCr = 1),
                this.state.perPageCr,
                this.state.sortBy2,
                this.state.searchMainSupportRoles
            );
        }
    };

    fetchPaginationList = (currentPage, perPage) => {
        this.setState(
            {
                currentPage: currentPage,
                perPage: perPage,
                isSortAscending: this.state.isSortAscending,
                sortBy: this.state.sortBy,
            },
            () => {
                this.getTeamList(currentPage, perPage);
            }
        );
    };

    handlePageChange = (pageNumber) => {
        if (this.state.isSkillMatrix === false) {
            this.state.currentPage = pageNumber;
            this.setState({}, () => {
                this.getTeamList(this.state.currentPage, this.state.perPage);
            });
        } else {
            this.setState({
                isMainRoleChanged: false,
                isCommitteeroleChanged: false,
                proficiencyError: false,
            });
            if (this.state.mainRoleBorder == true) {
                this.state.currentPageMr = pageNumber;

                this.setState({}, () => {
                    this.handleSkillMatrixPage(
                        this.state.mainUserId,
                        this.state.currentPageMr,
                        this.state.perPageMr,
                        this.state.employeeName,
                        this.state.employeeCode,
                        this.state.sortBy1,
                        this.state.searchMainSupportRoles,
                        false
                    );
                });
            } else if (this.state.supportroleBorder == true) {
                this.state.currentPageCr = pageNumber;
                this.setState({}, () => {
                    this.handleSkillMatrixPage1(
                        this.state.mainUserId,
                        this.state.currentPageCr,
                        this.state.perPageCr,
                        this.state.sortBy2,
                        this.state.searchMainSupportRoles
                    );
                });
            }
        }
    };

    find = (e) => {
        this.setState({
            isCommitteeroleChanged: false,
            isMainRoleChanged: false,
            proficiencyError: false,
        });
        if (this.state.isSkillMatrix == false) {
            this.state.perPage = e.value;
            this.state.pagingListValue = e;
            const selectedPage = 1;
            this.state.currentPage = selectedPage;
            this.setState({}, () => {
                this.getTeamList(this.state.currentPage, this.state.perPage);
            });
        } else if (
            this.state.mainRoleBorder == true &&
            this.state.skillMatrixList?.length > 0
        ) {
            this.state.perPageMr = e.value;
            this.state.paginListMainRole = e;
            const selectedPage = 1;
            this.state.currentPageMr = selectedPage;
            this.setState({}, () => {
                this.handleSkillMatrixPage(
                    this.state.mainUserId,
                    this.state.currentPageMr,
                    this.state.perPageMr,
                    this.state.employeeName,
                    this.state.employeeCode,
                    this.state.sortBy1,
                    this.state.searchMainSupportRoles,
                    false
                );
            });
        } else if (
            this.state.supportroleBorder == true &&
            this.state.supportingRolesList?.length > 0
        ) {
            this.state.perPageCr = e.value;
            this.state.pagingListCommitteeRole = e;
            const selectedPage = 1;
            this.state.currentPageCr = selectedPage;
            this.setState({}, () => {
                this.handleSkillMatrixPage1(
                    this.state.mainUserId,
                    this.state.currentPageCr,
                    this.state.perPageCr,
                    this.state.sortBy2,
                    this.state.searchMainSupportRoles
                );
            });
        }
    };

    handleSkillMatrixPageopen = (
        name,
        currentPage,
        perPage,
        Name,
        Code,
        sortBy,
        searchObj,
        getFilter
    ) => {
        this.setState(
            {
                heading: name,
                loader: true,
                mainUserId: name,
                currentPageMr: currentPage,
                employeeName: Name,
                employeeCode: Code,
                mainRoleBorder: true,
                supportroleBorder: false,
                isMainRoleChanged: false,
                isCommitteeroleChanged: false,
                proficiencyError: false,
            },
            () => {
                this.getGraphValue();
            }
        );
        let apiUrl = `${API.GET_TEAM_SKILL_CHART_BY_ID
            }?userId=${name}&role=mainrole&sortBy=${sortBy}&isSortAscending=${this.state.order1 == "asc" ? true : false
            }&pageNumber=${currentPage}&pageSize=${perPage}`;
        axios({
            method: "POST",
            url: apiUrl,
            data: searchObj,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.skillMatrixList = res.data.values;
                    this.state.mainRoleCount = res.data.totalCount;
                    this.setState({});
                    // if (getFilter != true) {
                    //   this.handleSkillMatrixPage1(
                    //     name,
                    //     currentPage,
                    //     this.state.perPageCr,
                    //     this.state.sortBy2
                    //   );
                    // }
                    this.setState({
                        loader: false,
                        isSkillMatrix: true,
                    });
                    // this.getGraphValue();
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ loader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    handleSkillMatrixInitial = (item) => {
        this.state.designationName = item.designation;
        this.state.employeeName = item.employeeName;
        this.state.employeeCode = item.employeeCode;
        // this.setState({
        //   loader: true
        // })
        // let apiurl = `${API.POST_ISUPDATE_SKILL_MATRIX}?userId=${this.state.UserId}&level=true&daterange=true`;
        // axios({
        //   method: "GET",
        //   url: apiurl,
        // })
        //   .then((res) => {
        //     if (res.status === 200) {
        //       this.state.isSkillMatrix = res.data.status;
        //       this.state.isSkillDateRange = res.data.status;
        //       this.state.loader = false;
        //       this.setState({});
        //       if (res.data?.status == true) {
        this.setState(
            {
                sortBy1: "jobGroup",
                order1: "asc",
                sortBy2: "jobGroup",
                order2: "asc",
                isMainRole: true,
            },
            () => {
                // this.getTeamUserDetails(item.id);
                this.handleSkillMatrixPageopen(
                    item.id,
                    1,
                    this.state.perPageMr,
                    item.employeeName,
                    item.employeeCode,
                    this.state.sortBy1,
                    this.state.searchMainSupportRoles,
                    false
                );
                this.getAuditLog(item.id);
                this.handleSkillMatrixInitialCheck();
            }
        );
        //     }else {
        //       this.setState({
        //         loader: false
        //       });
        //       if (res.data?.message) {
        //         toast.error(res.data?.message);
        //       }
        //     }
        //   }
        // }).catch((error) => {
        //   logoutFunction(error?.response?.status);
        //   console.log(error);
        //   this.setState({ loader: false });
        //   swal(
        //     "Error!",
        //     "Something went wrong. Please try again.",
        //     "warning"
        //   );
        // });
    };
    convertTimestamp(isoString) {
        const date = new Date(isoString);

        // Get individual date and time components
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const year = date.getFullYear();
        const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";

        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    }

    handleSkillMatrixInitialCheck = () => {
        let apiurl = `${API.POST_ISUPDATE_SKILL_MATRIX}?userId=${this.state.UserId}&level=true&daterange=true`;
        axios({
            method: "GET",
            url: apiurl,
        })
            .then((res) => {
                if (res.status === 200) {
                    if (res.data?.status == true) {
                        this.setState({
                            isLevelValidate: res.data.isLevelValidate,
                            isdateValidate: res.data.isdateValidate,
                            levelMessage: res.data.levelMessage,
                            dateMessage: res.data.dateMessage,
                        });
                    }
                    // else {
                    //   if (res.data?.message) {
                    //     toast.error(res.data?.message);
                    //   }
                    // }
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                // this.setState({ loader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    getAuditLog = (id) => {
        let apiUrl1 = `${API.GET_AUDIT_LOG}?userID=${id}`;
        axios({
            method: "GET",
            url: apiUrl1,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.auditLog = res.data;
                    this.setState({});
                }
            })
            .catch((error) => {
                console.log(error);
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    getTeamUserDetails = (id) => {
        let apiUrl1 = `${API.GET_TEAM_USER_DETAILS}?userID=${id}`;
        axios({
            method: "GET",
            url: apiUrl1,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.employeeName = res?.data?.userName;
                    this.state.employeeCode = res?.data?.userCode;
                    this.state.mainRoleName = res?.data?.mainRole;
                    this.state.committeeRoleName = res?.data?.committeeRole;
                    this.setState({});
                }
            })
            .catch((error) => {
                console.log(error);
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    handleSkillMatrixPage = (
        name,
        currentPage,
        perPage,
        Name,
        Code,
        sortBy,
        searchObj,
        getFilter
    ) => {
        this.setState(
            {
                heading: name,
                loader: true,
                mainUserId: name,
                currentPageMr: currentPage,
                employeeName: Name,
                employeeCode: Code,
            },
            () => {
                this.getGraphValue();
            }
        );
        let apiUrl = `${API.GET_TEAM_SKILL_CHART_BY_ID
            }?userId=${name}&role=mainrole&sortBy=${sortBy}&isSortAscending=${this.state.order1 == "asc" ? true : false
            }&pageNumber=${currentPage}&pageSize=${perPage}`;
        axios({
            method: "POST",
            url: apiUrl,
            data: searchObj,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.skillMatrixList = res.data.values;
                    this.state.mainRoleCount = res.data.totalCount;
                    this.setState({});
                    // if (getFilter != true) {
                    //   this.handleSkillMatrixPage1(
                    //     name,
                    //     currentPage,
                    //     this.state.perPageCr,
                    //     this.state.sortBy2
                    //   );
                    // }
                    this.setState({
                        loader: false,
                    });
                    // this.getGraphValue();
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ loader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    handleSkillMatrixPagemainrole = (
        name,
        currentPage,
        perPage,
        Name,
        Code,
        sortBy,
        searchObj,
        getFilter
    ) => {
        this.setState({
            heading: name,
            loader: true,
            mainUserId: name,
            currentPageMr: currentPage,
            employeeName: Name,
            employeeCode: Code,
        });
        let obj = {
            job: "",
            jobGroup: "",
            skillId: 0,
            skill: "",
            level: "",
            proficiency: "",
            proficiencyId: 0,
            levelId: 0,
            proficiencyExpectedId: 0,
            proficiencyExpected: "",
            courseProvider: "",
        };
        let apiUrl = `${API.GET_TEAM_SKILL_CHART_BY_ID
            }?userId=${name}&role=mainrole&sortBy=${sortBy}&isSortAscending=${this.state.order1 == "asc" ? true : false
            }&pageNumber=${currentPage}&pageSize=${perPage}`;
        axios({
            method: "POST",
            url: apiUrl,
            data: obj,
        })
            .then((res) => {
                this.state.skillMatrixList = res.data.values;
                this.state.mainRoleCount = res.data.totalCount;
                this.setState({});
                this.setState({
                    heading: name,
                    loader: false,
                });
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ loader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    handleSkillMatrixPagesupportrole = (
        name,
        currentPage,
        perPage,
        sortBy2,
        searchObj
    ) => {
        this.setState({
            heading: name,
            loader: true,
        });
        let obj = {
            job: "",
            jobGroup: "",
            skillId: 0,
            skill: "",
            level: "",
            proficiency: "",
            proficiencyId: 0,
            levelId: 0,
            proficiencyExpectedId: 0,
            proficiencyExpected: "",
            courseProvider: "",
        };
        let apiUrl = `${API.GET_TEAM_SKILL_CHART_BY_ID
            }?userId=${name}&role=supportrole&sortBy=${sortBy2}&isSortAscending=${this.state.order2 == "asc" ? true : false
            }&pageNumber=${currentPage}&pageSize=${perPage}`;
        axios({
            method: "POST",
            url: apiUrl,
            data: obj,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.supportingRolesList = res.data.values;
                    this.state.supportRoleCount = res.data.totalCount;
                    this.setState({
                        heading: name,
                        loader: false,
                    });
                    this.setState({});
                    // this.getGraphValue();
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ loader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    handleSkillMatrixPage1 = (name, currentPage, perPage, sortBy2, searchObj) => {
        this.setState({
            heading: name,
            loader: true,
        });
        let apiUrl = `${API.GET_TEAM_SKILL_CHART_BY_ID
            }?userId=${name}&role=supportrole&sortBy=${sortBy2}&isSortAscending=${this.state.order2 == "asc" ? true : false
            }&pageNumber=${currentPage}&pageSize=${perPage}`;
        axios({
            method: "POST",
            url: apiUrl,
            data: searchObj,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.supportingRolesList = res.data.values;
                    this.state.supportRoleCount = res.data.totalCount;
                    this.setState({
                        heading: name,
                        loader: false,
                    });
                    this.setState({});
                    // this.getGraphValue();
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ loader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };
    getScrollParent = (el) => {
        let p = el && el?.parentElement;
        while (p) {
            const style = getComputedStyle(p);
            const oy = style.overflowY;
            if (
                (oy === "auto" || oy === "scroll") &&
                p.scrollHeight > p.clientHeight
            ) {
                return p;
            }
            p = p.parentElement;
        }
        return null;
    };

    //   scrollToRowId = (rowId, offset = 0) => {
    //      ;
    //     const row = document.getElementById(rowId);
    //     if (!row) return;

    //     const container = this.getScrollParent(row);
    //     if (!container) return;

    //     // 🚀 position row's top at the top of container
    //     const rowTop = row.offsetTop - container.offsetTop;

    //     const y = container.getBoundingClientRect().top + window.pageYOffset - 150;
    //     window.scrollTo({
    //       top: y,
    //       behavior: "smooth",
    //     });

    //     requestAnimationFrame(() => {
    //       const rowTop = row.offsetTop - container.offsetTop;
    //       container.scrollTo({
    //         top: rowTop,
    //         behavior: "smooth",
    //       });
    //     });

    //     // highlight optional
    //     row.classList.add("highlight-row");
    //     setTimeout(() => row.classList.remove("highlight-row"), 1500);
    //   };

    scrollToRowId = (rowId, offset = 0) => {
        const row = document.getElementById(rowId);
        if (!row) return;

        const container = this.getScrollParent(row);
        if (!container) return;

        // row.offsetTop is already relative to the container’s scrollable content
        let targetScroll = row.offsetTop - offset;

        // clamp so we don’t overshoot the bottom
        const maxScroll = container.scrollHeight - container.clientHeight;
        if (targetScroll > maxScroll) targetScroll = maxScroll;

        container.scrollTo({
            top: targetScroll,
            behavior: "smooth",
        });

        // also scroll page to show container near top of viewport (leave space for header)
        const y = container.getBoundingClientRect().top + window.pageYOffset - 160;
        window.scrollTo({ top: y, behavior: "smooth" });

        // highlight row
        row.classList.add("highlight-row");
        setTimeout(() => row.classList.remove("highlight-row"), 1500);
    };

    UpdateSkillData = (role) => {
        if (role == "main") {
            this.state.skillMatrixList?.map((skill) => {
                skill.userId = this.state.mainUserId;
            });
        } else {
            this.state.supportingRolesList?.map((support) => {
                support.userId = this.state.mainUserId;
            });
        }
        this.setState({});

        // var value = [
        //   ...this.state.skillMatrixList,
        //   ...this.state.supportingRolesList,
        // ].filter((item) => {
        //   return item.proficiencyId !== 0 && item.proficiency !== "";
        // });
        // var value = [
        //   ...this.state.skillMatrixList.map((item) => ({
        //     ...item,
        //     sortOrderByJobGroup: null,
        //     sortOrderByJobName: null,
        //   })),
        //   ...this.state.supportingRolesList.map((item) => ({
        //     ...item,
        //     sortOrderByJobGroup: null,
        //     sortOrderByJobName: null,
        //   })),
        // ]
        // .filter((item) => {
        //   return item.proficiencyId !== 0 && item.proficiency !== "";
        // });
        let value = [];

        if (role === "main") {
            value = this.state.skillMatrixList.map((item) => ({
                ...item,
                sortOrderByJobGroup: null,
                sortOrderByJobName: null,
            }));
        } else {
            value = this.state.supportingRolesList.map((item) => ({
                ...item,
                sortOrderByJobGroup: null,
                sortOrderByJobName: null,
            }));
        }

        var hasInvalid = value.some(
            (item) => item.proficiencyId === 0 || item.proficiency === ""
        );
        console.log(hasInvalid, " mandatory variable");
        let userid = this.state.UserId;
        let apiUrl = `${API.UPDATE_TEAM_SKILL_CHART}?userId=${this.state.UserId}`;
        if (hasInvalid) {
            this.setState({ proficiencyError: true });
            const firstInvalid = value.findIndex(
                (item) => item.proficiencyId === 0 || item.proficiency === ""
            );
            let tableId = "";
            if (role == "main") {
                tableId = "activematrix" + firstInvalid;
            } else {
                tableId = "activerole" + firstInvalid;
            }
            swal("Error!", "Fill all the mandatory fields.", "warning");
            if (tableId) {
                //   const row = document.getElementById(tableId);
                //   if (row) {
                //     row.scrollIntoView({ behavior: "smooth", block: "center" });
                //     // optional: add a highlight effect
                //     row.classList.add("highlight-row");
                //     setTimeout(() => row.classList.remove("highlight-row"), 2000);
                //   }
                this.scrollToRowId(tableId, 40);
            }
            //   if (tableId) {
            //      ;
            //     const row = document.getElementById(tableId);
            //     if (row) {
            //       // find the scrollable parent (tbody or div wrapper)
            //       let container = row.closest("tbody");

            //       // if tbody itself is not scrollable, try wrapper div
            //       if (container && container.scrollHeight <= container.clientHeight) {
            //         container = container.parentElement;
            //       }

            //       if (container) {
            //         container.scrollTop = row.offsetTop - container.offsetTop - 20; // adjust offset
            //       }

            //       // optional highlight
            //       row.classList.add("highlight-row");
            //       setTimeout(() => row.classList.remove("highlight-row"), 2000);
            //     }
            //   }
        } else {
            this.setState({ proficiencyError: false });
            this.setState({ loader: true });
            axios({
                method: "PUT",
                url: apiUrl,
                data: value,
            })
                .then((res) => {
                    if (res.status === 200) {
                        this.handleSkillMatrixPage(
                            this.state.mainUserId,
                            this.state.currentPage,
                            this.state.perPage,
                            this.state.employeeName,
                            this.state.employeeCode,
                            this.state.sortBy1,
                            this.state.searchMainSupportRoles,
                            true
                        );
                        this.getAuditLog(this.state.mainUserId);
                        this.handleSkillMatrixPage1(
                            this.state.mainUserId,
                            this.state.currentPage,
                            this.state.perPage,
                            this.state.sortBy2,
                            this.state.searchMainSupportRoles
                        );
                        this.getCapabilitySummary();
                        this.setState({
                            isCommitteeroleChanged: false,
                            isMainRoleChanged: false,
                            proficiencyError: false,
                        });
                        this.setState({ loader: false });
                        this.submitToast();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loader: false });
                    logoutFunction(error?.response?.status);
                    swal("Error!", "Something went wrong. Please try again.", "warning");
                });
        }
    };

    submitToast = () => {
        toast.success("Submitted successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
        });
    };

    certificateUploadToast = () => {
        toast.success("Certificate uploaded successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
        });
    };

    changeRating = (e, name, type) => {
        let noOfStars =
            type === "skillMatrixList"
                ? this.state.skillMatrixList[name].mastery
                : this.state.supportingRolesList[name].mastery;

        if (noOfStars == 1 && e == 1) {
            type === "skillMatrixList"
                ? (this.state.skillMatrixList[name].mastery = 0)
                : (this.state.supportingRolesList[name].mastery = 0);
            this.setState({});
        } else {
            type === "skillMatrixList"
                ? (this.state.skillMatrixList[name].mastery = e)
                : (this.state.supportingRolesList[name].mastery = e);
            this.setState({});
        }
        if (type == "skillMatrixList") {
            this.setState({ isMainRoleChanged: true });
        } else {
            this.setState({ isCommitteeroleChanged: true });
        }
    };

    // Search Functionalities

    onchangeProficiecy = (e, index, type) => {
        type === "skillMatrixList"
            ? (this.state.skillMatrixList[index].proficiencyId = parseInt(
                e.value.split(",")[0]
            ))
            : (this.state.supportingRolesList[index].proficiencyId = parseInt(
                e.value.split(",")[0]
            ));
        type === "skillMatrixList"
            ? (this.state.skillMatrixList[index].proficiency = e.value.split(",")[1])
            : (this.state.supportingRolesList[index].proficiency =
                e.value.split(",")[1]);
        type === "skillMatrixList"
            ? (this.state.skillMatrixList[index].mastery = 0)
            : (this.state.supportingRolesList[index].mastery = 0);
        this.setState({});
        if (type == "skillMatrixList") {
            this.setState({ isMainRoleChanged: true });
        } else {
            this.setState({ isCommitteeroleChanged: true });
        }
    };

    openSearch = () => {
        // let myOffcanvas = new window.bootstrap.Offcanvas(
        //   document.getElementById("searchScreen")
        // );
        // myOffcanvas.show();
        $("body").addClass("scrollhide");
        $("#searchScreen").addClass("show");
        this.setState({ validationMsg: false, searchScreen: true });
        // this.getEmployeeName();
        // this.getEmployeeList();
    };

    openSearch1 = () => {
        // let myOffcanvas = new window.bootstrap.Offcanvas(
        //   document.getElementById("searchScreen1")
        // );
        // myOffcanvas.show();
        this.setState({ validationMsg: false });
        this.setState({ searchScreen1: true });
        $("#searchScreen1").addClass("show");
        $("body").addClass("scrollhide");
        this.getProficiencyList();
        // this.getEmployeeName();
        // this.getEmployeeList();
    };

    filterMainCommitteeRoles = () => {
        $("body").addClass("scrollhide");
        $("#mainCommitteeRolesModal").addClass("show");
    };

    getEmployeeName = () => {
        // this.setState({ loader: true });
        const { UserId } = this.state;
        let apiUrl = `${API.GET_EMPLOYEES}?userId=${UserId}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.employeeList = res?.data?.map((employee) => {
                        return {
                            value: employee.employeeName,
                            label: (
                                <>
                                    <span>{employee.employeeName}</span>
                                </>
                            ),
                        };
                    });
                    // this.setState({
                    //     loader: false,
                    // });
                }
            })
            .catch((err) => {
                console.log(err);
                // logoutFunction(err?.response?.status);
                // this.setState({ loader: false });
                // swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    clearAllData = () => {
        this.setState({
            isSearch: false,

            validationMsg: false,
            searchInputData: {
                employeeCode: "",
                employeeName: "",
                designation: "",
                email: "",
                phoneNumber: "",
                status: "",
                supervisor: "",
                department: ""
            },
            employeeList: [],
            selectEmployeeName: [],
            selectedStatus: [],
        });
    };

    clearSearchFields = () => {
        this.state.currentPage = 1;
        // this.state.pageNewCount = !this.state.pageNewCount;
        this.clearAllData();
        this.setState({ searchScreen: false }, () =>
            this.getTeamList(this.state.currentPage, this.state.perPage)
        );
        $("#searchScreen").removeClass("show");

        $("body").removeClass("scrollhide");
    };
    clearSearchCapabilitySummaryFields = (event) => {
        this.setState({
            selectedProficiencyId: [],
            validationMsg: false,
            selectedDepartmentId: null,
            isSearchApplied: false,
        });
        this.setState({ selectedDepartmentId: null }, () => {
            this.getCapabilitySummary();
            this.setState({ capabilitySummaryData: [] });
        });
        // $("#searchScreen1").removeClass("show");
        this.setState({ searchScreen1: false });
        $("#searchScreen1").removeClass("show");

        $("body").removeClass("scrollhide");
    };

    onchangeEmployeeName = (e, field) => {
        if (e === null) {
            this.state.searchInputData[field] = "";
            this.state.selectEmployeeName = [];
            this.setState({});
        } else {
            this.state.searchInputData[field] = e.label;
            this.state.selectEmployeeName = e;
            this.setState({});
        }
    };
    onchangeStatus = (e, field) => {
        if (e === null) {
            this.state.searchInputData[field] = "";
            this.state.selectedStatus = [];
            this.setState({});
        } else {
            this.state.searchInputData[field] = e.label;
            this.state.selectedStatus = e;
            this.setState({});
        }
    };

    searchSupportRoleList = () => {
        const inputs = document.querySelectorAll(".searchInputs[required]");
        const isValid = Array?.from(inputs)?.some((input) => input.value !== "");
        const isValid1 = this.state.selectEmployeeName?.length !== 0;
        const isValid2 = this.state.selectedStatus?.length !== 0;
        const isValid3 = this.state.searchInputData?.department !== "" && this.state.searchInputData?.department !== null && this.state.searchInputData?.department !== undefined;
        if (isValid || isValid1 || isValid2 || isValid3) {
            this.submitSearchDetails();
            this.setState({
                validationMsg: false,
            });
        } else {
            this.setState({
                validationMsg: true,
            });
        }
    };

    searchCapabilitysummary = (e) => {
        if (
            this.state.selectedDepartmentId == null ||
            this.state.selectedDepartmentId == undefined ||
            this.state.selectedDepartmentId?.id == 0 ||
            this.state.selectedDepartmentId == 0 ||
            this.state.selectedDepartmentId?.id == ""
        ) {
            this.setState({ validationMsg: true, isSearchApplied: false });
        } else {
            this.setState({ validationMsg: false, isSearchApplied: true });
            this.getCapabilitySummary();
            $("#searchScreen1").removeClass("show");
            this.setState({ searchScreen1: false });
            $("body").removeClass("scrollhide");
        }

        // const inputs = document.querySelectorAll(".searchInputs[required]");
        // const isValid = Array?.from(inputs)?.some((input) => input.value !== "");
        // const isValid1 = this.state.selectEmployeeName?.length !== 0;
        // const isValid2 = this.state.selectedStatus?.length !== 0;
        // if (isValid || isValid1 || isValid2) {
        //   this.submitSearchDetails();
        //   this.setState({
        //     validationMsg: false,
        //   });
        // } else {
        //   this.setState({
        //     validationMsg: true,
        //   });
        // }
    };

    submitSearchDetails = () => {
        this.state.isSearch = true;
        // this.state.currentPage = 1;
        // this.state.perPage = 20;
        // this.state.pagingListValue= [{ label: "20", value: 20 }]
        // this.state.pageNewCount = !this.state.pageNewCount;
        this.setState(
            {
                currentPage: 1,
                pagingListValue: [{ label: "20", value: 20 }],
                perPage: 20,
                searchScreen: false,
            },
            () => this.getTeamList(this.state.currentPage, this.state.perPage)
        );
        $("#searchScreen").removeClass("show");
        $("body").removeClass("scrollhide");
    };

    handleInputchange(e, field) {
        this.state.searchInputData[field] = e.target.value;
        this.setState({});
    }

    searchFilterData = (obj) => {
        this.setState({
            isCommitteeroleChanged: false,
            isMainRoleChanged: false,
            proficiencyError: false,
        });
        if (this.state.isMainRole == true) {
            this.setState(
                {
                    currentPage: 1,
                    searchMainSupportRoles: obj,
                    sortBy: "jobGroup",
                    currentPageMr: 1,
                    currentPageCr: 1,
                    paginListMainRole: [{ label: "20", value: 20 }],
                    pagingListCommitteeRole: [{ label: "20", value: 20 }],
                    perPageMr: 20,
                    perPageCr: 20,
                },
                () => {
                    this.handleSkillMatrixPage(
                        this.state.mainUserId,
                        this.state.currentPageMr,
                        this.state.perPageMr,
                        this.state.employeeName,
                        this.state.employeeCode,
                        this.state.sortBy1,
                        obj,
                        true
                    );
                }
            );
        }
        if (this.state.isSupportRole == true) {
            this.setState(
                {
                    currentPage: 1,
                    searchMainSupportRoles: obj,
                    sortBy: "jobGroup",
                    currentPageMr: 1,
                    currentPageCr: 1,
                    paginListMainRole: [{ label: "20", value: 20 }],
                    pagingListCommitteeRole: [{ label: "20", value: 20 }],
                    perPageMr: 20,
                    perPageCr: 20,
                },
                () => {
                    this.handleSkillMatrixPage1(
                        this.state.mainUserId,
                        this.state.currentPageCr,
                        this.state.perPageCr,
                        this.state.sortBy2,
                        obj
                    );
                }
            );
        }
    };

    clearFilterData = (obj) => {
        this.setState({
            isCommitteeroleChanged: false,
            isMainRoleChanged: false,
            proficiencyError: false,
        });
        if (this.state.isMainRole == true) {
            this.setState(
                {
                    currentPage: 1,
                    searchMainSupportRoles: obj,
                },
                () => {
                    this.handleSkillMatrixPage(
                        this.state.mainUserId,
                        1,
                        this.state.perPage,
                        this.state.employeeName,
                        this.state.employeeCode,
                        this.state.sortBy1,
                        obj,
                        true
                    );
                }
            );
        }
        if (this.state.isSupportRole == true) {
            this.setState(
                {
                    currentPage: 1,
                    searchMainSupportRoles: obj,
                },
                () => {
                    this.handleSkillMatrixPage1(
                        this.state.mainUserId,
                        1,
                        this.state.perPage,
                        this.state.sortBy2,
                        obj
                    );
                }
            );
        }
    };

    clearFilterData1 = (obj) => {
        this.setState({
            currentPage: 1,
            searchMainSupportRoles: obj,
        });
    };

    showDateErrorMessage = () => {
        if (this.state.isdateValidate == false) {
            if (!this.state.iserrordatetoastVisible) {
                this.state.iserrordatetoastVisible = true;
                toast.error(this.state.dateMessage, {
                    onClose: () => {
                        this.state.iserrordatetoastVisible = false;
                    },
                });
            }
        }
    };

    showLevelErrorMessage = () => {
        if (!this.state.iserrortoastVisible) {
            this.state.iserrortoastVisible = true;
            toast.error(this.state.levelMessage, {
                onClose: () => {
                    this.state.iserrortoastVisible = false;
                },
            });
        }
    };

    changeCommittee = () => {
        this.setState({
            mainRoleBorder: false,
            supportroleBorder: true,
            isMainRole: false,
            isSupportRole: true,
            currentPageMr: 1,
            currentPageCr: 1,
            paginListMainRole: [{ label: "20", value: 20 }],
            pagingListCommitteeRole: [{ label: "20", value: 20 }],
            perPageMr: 20,
            perPageCr: 20,
        });
        if (this.state.isMainRole == true) {
            this.setState({
                isMainRoleChanged: false,
                proficiencyError: false,
            });
            this.handleSkillMatrixPagesupportrole(
                this.state.mainUserId,
                (this.state.currentPageCr = 1),
                this.state.perPageCr,
                this.state.sortBy2,
                this.state.searchMainSupportRoles
            );
        }
    };

    changeMain = () => {
        this.setState({
            mainRoleBorder: true,
            supportroleBorder: false,
            isMainRole: true,
            isSupportRole: false,
            currentPageMr: 1,
            currentPageCr: 1,
            paginListMainRole: [{ label: "20", value: 20 }],
            pagingListCommitteeRole: [{ label: "20", value: 20 }],
            perPageMr: 20,
            perPageCr: 20,
        });
        if (this.state.isMainRole !== true) {
            this.setState({
                isCommitteeroleChanged: false,
                proficiencyError: false,
            });
            this.handleSkillMatrixPagemainrole(
                this.state.mainUserId,
                1,
                this.state.perPageMr,
                this.state.employeeName,
                this.state.employeeCode,
                this.state.sortBy1,
                this.state.searchMainSupportRoles,
                false
            );
        }
    };

    executeWithConfirm = (condition, callback, message = "Are you sure?") => {
        if (!condition) {
            callback();
        } else {
            swal({
                title: "",
                icon: "warning",
                content: {
                    element: "div",
                    attributes: {
                        innerHTML: `<span style="font-size:18px">${message}</span>`,
                    },
                },
                buttons: ["No", "Yes"], // Cancel, Confirm
                dangerMode: true,
            }).then((willDo) => {
                if (willDo) {
                    callback();
                }
            });
        }
    };

    getDepartmentDropDown = async () => {
        let apiUrl = `${API.GET_DEPARTMENT_NAME}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.departmentNameList = res?.data?.map((departmentName) => {
                        return {
                            value: departmentName.value,
                            id: departmentName.id,
                            key: departmentName.id,
                            label: (
                                <>
                                    <span>{departmentName.value}</span>
                                </>
                            ),
                        };
                    });
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ isRequestLoader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
        // let getDeparmentApiUrl = `${API.GET_DEPARTMENT_NAME}`;
        // await axios
        //   .get(getDeparmentApiUrl)
        //   .then((response) => {
        //     if (response?.status === 200) {
        //       this.setState({ departmentNameList: response.data })
        //     }
        //   })
        //   .catch(error => {
        //     logoutFunction(error?.response?.status);
        //     console.log(error)
        //   });
    };

    onChangeDepartment = (e) => {
        this.setState({ selectedDepartmentId: e }, () => {
            this.getCapabilitySummary();
        });
    };

    render() {
        const {
            sortBy,
            order,
            series,
            sortBy1,
            order1,
            sortBy2,
            order2,
            currentUser,
            skillMatrixList,
            supportingRolesList,
            width,
            isMobile,
            pageCount,
            myTeamList,
            isSkillMatrix,
            isMobile450,
            isMobile350,
            isMobile650,
            isMobile900,
            mainRoleBorder,
            supportroleBorder,
            isCapabilitySummary,
            isDirect2,
            auditLog,
        } = this.state;
        let { classes, menuToggle } = this.props;
        const paginglist = [
            { label: "5", value: 5 },
            { label: "10", value: 10 },
            { label: "20", value: 20 },
            { label: "50", value: 50 },
        ];
        const paginglistDefault = [{ label: "20", value: 20 }];

        return (
            <>
                {$("#searchScreen").hasClass("show") ||
                    $("#searchScreen1").hasClass("show") ? (
                    <div className="viewbar-overlay"></div>
                ) : (
                    <></>
                )}

                <Toaster />
                <LoaderVisible isLoader={this.state.loader} />

                <div
                    className={`${isMobile
                        ? "main-body-mobile table-responsive-xl"
                        : menuToggle
                            ? "menu-main-body table-responsive-xl"
                            : "main-body table-responsive-xl"
                        } `}
                >
                    {isSkillMatrix && (
                        <>
                            {isMobile == true ? (
                                <div className="mobile-head border-bottom w-100">
                                    <div className="col-12 mobile-title">
                                        {"Capability chart"}
                                    </div>
                                </div>
                            ) : (
                                <div className="head-fixed">
                                    <div className="title">
                                        <>
                                            <CommonIcon fileName="Skillmatrixicon" />
                                            <span className="pl-10 head-span">
                                                {"Capability chart"}
                                            </span>
                                        </>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    {!isSkillMatrix && (
                        <>
                            {isMobile == true ? (
                                // <div className="d-flex w-100 row mobile-head border-bottom pr-0">
                                //   <div className="col-10 mobile-title">Team's capability chart</div>
                                //   <div className="filter-icon col-2 text-align-end">
                                //     <span
                                //       className="cursor-pointer"
                                //       onClick={() => this.openSearch()}
                                //     >
                                //       <CommonIcon fileName="filterIcon" />
                                //     </span>
                                //   </div>
                                // </div>
                                <div className={`p-0 mr-0 w-80 `}>
                                    <span
                                        className={`mobile-head border-bottom w-100 d-flex justify-content-between`}
                                    >
                                        <span className="mobile-title">
                                            Competency grading
                                        </span>
                                        {!isCapabilitySummary && (
                                            <span onClick={() => this.openSearch()}>
                                                <CommonIcon fileName="searchIcon1" />
                                            </span>
                                        )}
                                        {isCapabilitySummary && (
                                            <span onClick={() => this.openSearch1()}>
                                                <CommonIcon fileName="searchIcon1" />
                                            </span>
                                        )}
                                    </span>
                                </div>
                            ) : (
                                <div className="head-fixed">
                                    <div
                                        className={` ${menuToggle ? "width-100" : "width-filter"
                                            } px-4 position-relative border-bottom row `}
                                    >
                                        <div className="col-6 border-none title">
                                            <CommonIcon fileName="skillActiveIcon" />
                                            <span className="pl-10 head-span">
                                                Competency grading
                                            </span>
                                        </div>
                                        {!isCapabilitySummary && (
                                            <div className="text-align-end title border-none display text-16-red mt-3px col-6">
                                                <span
                                                    className="text-20-bold pr-30 cursor-pointer"
                                                    onClick={() => this.openSearch()}
                                                >
                                                    <CommonIcon fileName="filterIcon" />
                                                </span>
                                            </div>
                                        )}
                                        {isCapabilitySummary && (
                                            <div className="text-align-end title border-none display text-16-red mt-3px col-6">
                                                <span
                                                    className="text-20-bold pr-30 cursor-pointer"
                                                    onClick={() => this.openSearch1()}
                                                >
                                                    <CommonIcon
                                                        fileName={
                                                            this.state.isSearchApplied
                                                                ? "filterIconFill"
                                                                : "filterIcon"
                                                        }
                                                    />
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                    {/* table */}
                    {!isSkillMatrix && (
                        <>
                            <ul
                                class={`nav nav-tabs tabs-nowrap ${isMobile
                                    ? "table-scroll-xy-mobile top-105px"
                                    : "table-scroll-xy2"
                                    } `}
                                id="myTab"
                                role="tablist"
                            >
                                {/* <li class="nav-item" role="presentation">
                  <button
                    class={`active tabsButton cursor-pointer `}
                    id="MainRoles-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#MainRoles"
                    type="button"
                    role="tab"
                    aria-controls="MainRoles"
                    aria-selected="true"
                    onClick={() => {
                      this.setState(
                        {
                          isCapabilitySummary: false,
                          isDirect2: false,
                        },
                        () => {
                          this.changeCapabilitytabs();
                        }
                      );
                    }}
                  >
                    <span
                      className={`${
                        !isCapabilitySummary && !isDirect2
                          ? "border-bottom-red pbo-5 text-danger"
                          : ""
                      }`}
                    >
                      Teams capability
                    </span>
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class={`active tabsButton cursor-pointer `}
                    id="MainRoles-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#MainRoles"
                    type="button"
                    role="tab"
                    aria-controls="MainRoles"
                    aria-selected="true"
                    onClick={() => {
                      this.setState(
                        {
                          isCapabilitySummary: false,
                          isDirect2: true,
                        },
                        () => {
                          this.changeCapabilitytabs();
                        }
                      );
                    }}
                  >
                    <span
                      className={`${
                        isDirect2 && !isCapabilitySummary
                          ? "border-bottom-red pbo-5 text-danger"
                          : ""
                      }`}
                    >
                      Teams capability (Direct 2)
                    </span>
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class={`tabsButton cursor-pointer`}
                    id="CommitteeRoles-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#CommitteeRoles"
                    type="button"
                    role="tab"
                    aria-controls="CommitteeRoles"
                    aria-selected="false"
                    onClick={() => {
                      this.setState(
                        {
                          isCapabilitySummary: true,
                          isDirect2: false,
                          selectedDepartmentId: null,
                          selectedProficiencyId: [],
                          capabilitySummaryData: [],
                          isSearchApplied: false,
                        },
                        () => {
                          this.getCapabilitySummary();
                        }
                      );
                    }}
                  >
                    <span
                      className={` ${
                        isCapabilitySummary && !isDirect2
                          ? "border-bottom-red pbo-5 text-danger"
                          : ""
                      }`}
                    >
                      Capability summary
                    </span>
                  </button>
                </li> */}
                                {!isCapabilitySummary && (
                                    <li className="nav-item ms-auto ps-4 padToplegend">
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "12px",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                            }}
                                        >
                                            {this.state.legendItems.map((item) => (
                                                <div
                                                    key={item.label}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "4px",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            width: "12px",
                                                            height: "12px",
                                                            marginTop: "2px",
                                                            backgroundColor: item.color,
                                                            borderRadius: "0px",
                                                        }}
                                                    />
                                                    {item.label}
                                                </div>
                                            ))}
                                        </div>
                                    </li>
                                )}
                            </ul>

                            {!isCapabilitySummary ? (
                                <div
                                    className={`${isMobile
                                        ? "common-mobiletable-style"
                                        : "teamSkill-table-style1"
                                        } table-responsive `}
                                >
                                    <div
                                        className={`${isMobile
                                            ? "table-scroll-xy-mobile1 top-135px"
                                            : menuToggle
                                                ? "table-scroll-xy-menutoggle1"
                                                : "table-scroll-xy1"
                                            } table-list-view-bottom table-fixed-header`}
                                    >
                                        <table className="table fileListTable2 tableBorderTop table-borderless table-hover ">
                                            <thead>
                                                <tr>
                                                    <td></td>
                                                    <td
                                                        className="cursor-pointer"
                                                        onClick={() => this.sortTable("employeeCode")}
                                                    >
                                                        <span> Employee code </span>
                                                        {sortBy === "employeeCode" && (
                                                            <CommonIcon
                                                                fileName={
                                                                    order === "asc" ? "upArrow" : "downArrow"
                                                                }
                                                            />
                                                        )}
                                                    </td>
                                                    <td
                                                        className="cursor-pointer"
                                                        onClick={() => this.sortTable("employeeName")}
                                                    >
                                                        <span>Employee name</span>
                                                        {sortBy === "employeeName" && (
                                                            <CommonIcon
                                                                fileName={
                                                                    order === "asc" ? "upArrow" : "downArrow"
                                                                }
                                                            />
                                                        )}
                                                    </td>
                                                    <td
                                                        className="cursor-pointer"
                                                        onClick={() => this.sortTable("status")}
                                                    >
                                                        <span>Status</span>
                                                        {sortBy === "status" && (
                                                            <CommonIcon
                                                                fileName={
                                                                    order === "asc" ? "upArrow" : "downArrow"
                                                                }
                                                            />
                                                        )}
                                                    </td>
                                                    {localStorage
                                                        .getItem("Role")
                                                        .split(",")
                                                        .includes("manager") && (
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable("supervisor")}
                                                            >
                                                                <span>Supervisor</span>
                                                                {sortBy === "supervisor" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                        )}
                                                    <td
                                                        className="cursor-pointer"
                                                        onClick={() => this.sortTable("department")}
                                                    >
                                                        <span> Department</span>
                                                        {sortBy === "department" && (
                                                            <CommonIcon
                                                                fileName={
                                                                    order === "asc" ? "upArrow" : "downArrow"
                                                                }
                                                            />
                                                        )}
                                                    </td>
                                                    <td
                                                        className="cursor-pointer"
                                                        onClick={() => this.sortTable("designation")}
                                                    >
                                                        <span> Designation</span>
                                                        {sortBy === "designation" && (
                                                            <CommonIcon
                                                                fileName={
                                                                    order === "asc" ? "upArrow" : "downArrow"
                                                                }
                                                            />
                                                        )}
                                                    </td>
                                                    {/* <td
                            className="cursor-pointer"
                            onClick={() => this.sortTable("email")}
                          >
                            <span> Email</span>
                            {sortBy === "email" && (
                              <CommonIcon
                                fileName={
                                  order === "asc" ? "upArrow" : "downArrow"
                                }
                              />
                            )}
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() => this.sortTable("phoneNumber")}
                          >
                            <span> Phone number</span>
                            {sortBy === "phoneNumber" && (
                              <CommonIcon
                                fileName={
                                  order === "asc" ? "upArrow" : "downArrow"
                                }
                              />
                            )}
                          </td> */}
                                                    <td width={"20%"} className="">
                                                        <span> Proficiency</span>
                                                    </td>
                                                </tr>
                                            </thead>
                                            {
                                                myTeamList && myTeamList.length !== 0 ? (
                                                    <tbody>
                                                        {myTeamList.map((item, index) => (
                                                            <tr
                                                                id={"active" + item.id}
                                                                key={index}
                                                                className="requestRadioSelect"
                                                            >
                                                                <td></td>
                                                                <td>
                                                                    <span
                                                                        onClick={
                                                                            // this.state.isSkillMatrix=true;
                                                                            // this.setState({})
                                                                            () => this.handleSkillMatrixInitial(item)
                                                                        }
                                                                    >
                                                                        <a className="properties-view cursor-pointer">
                                                                            {item.employeeCode
                                                                                ? item.employeeCode
                                                                                : "-"}
                                                                        </a>
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        {item.employeeName
                                                                            ? item.employeeName
                                                                            : "-"}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>{item.status ? item.status : "-"}</span>
                                                                </td>
                                                                {localStorage
                                                                    .getItem("Role")
                                                                    .split(",")
                                                                    .includes("manager") && (
                                                                        <td>
                                                                            <span>
                                                                                {item.supervisor ? item.supervisor : "-"}
                                                                            </span>
                                                                        </td>
                                                                    )}
                                                                <td>
                                                                    <span>
                                                                        {item.department ? item.department : "-"}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        {item.designation ? item.designation : "-"}
                                                                    </span>
                                                                </td>
                                                                <td width={"20%"}>
                                                                    <SkillBar
                                                                        data={item.mainroleJobProficiency}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {/* {myTeamList.filter(
                              (item) => item.directType !== "Direct1"
                            ).length > 0 ? (
                              <>
                                <tr className="table-section-header">
                                  <td className="table-section-header"></td>
                                  <td
                                    className="table-section-header"
                                    style={{ textAlign: "left" }}
                                    colSpan={6}
                                  >
                                    Direct 2
                                  </td>
                                </tr>
                                {myTeamList
                                  .filter(
                                    (item) => item.directType !== "Direct1"
                                  )
                                  .map((item, index) => (
                                    <tr
                                      id={"active" + item.id}
                                      key={index}
                                      className="requestRadioSelect"
                                    >
                                      <td></td>
                                      <td>
                                        <span
                                          onClick={
                                            // this.state.isSkillMatrix=true;
                                            // this.setState({})
                                            () =>
                                              this.handleSkillMatrixInitial(
                                                item
                                              )
                                          }
                                        >
                                          <a className="properties-view cursor-pointer">
                                            {item.employeeCode
                                              ? item.employeeCode
                                              : "-"}
                                          </a>
                                        </span>
                                      </td>
                                      <td>
                                        <span>
                                          {item.employeeName
                                            ? item.employeeName
                                            : "-"}
                                        </span>
                                      </td>
                                      <td>
                                        <span>
                                          {item.status ? item.status : "-"}
                                        </span>
                                      </td>
                                      {localStorage
                                        .getItem("Role")
                                        .split(",")
                                        .includes("manager") && (
                                        <td>
                                          <span>
                                            {item.supervisor
                                              ? item.supervisor
                                              : "-"}
                                          </span>
                                        </td>
                                      )}
                                      <td>
                                        <span>
                                          {item.designation
                                            ? item.designation
                                            : "-"}
                                        </span>
                                      </td>
                                      <td width={"18%"}>
                                        <SkillBar
                                          data={item.mainroleJobProficiency}
                                        />
                                      </td>
                                    </tr>
                                  ))}
                              </>
                            ) : (
                              <></>
                            )} */}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan={8}>No team members</td>
                                                        </tr>
                                                    </tbody>
                                                )
                                                //  <div className='noDataTextContainer'><span className='noDataText'>No team members</span></div>
                                            }
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div
                                        className={`${isMobile
                                            ? "table-scroll-xy-mobile1 top-135px"
                                            : "table-scroll-xy1"
                                            } w-auto height-250px  px-3 chart-bottom`}
                                    >
                                        {console.log(this.state.capabilitySummaryData)}
                                        <SkillChart data={this.state.capabilitySummaryData} />
                                        {/* <SkillBar
                      data={{
                        master: 30,
                        competent: 40,
                        learning: 20,
                        novice: 10,
                      }}
                    /> */}
                                    </div>
                                </>
                            )}
                        </>
                    )}

                    {isSkillMatrix && (
                        <>
                            {/* New SkillChart */}
                            {/* <div className=" table-responsive table-responsive-scroll scroll-x "> */}
                            <div className=" table-responsive scroll-x ">
                                <div
                                    className={` ${isMobile ? "skill-matrix-mobile" : "skill-matrix"
                                        } px-4  pb-20 text-20-bold no-wrap min-width-circle `}
                                >
                                    My job skills & competency
                                </div>
                                <div className="d-flex gap-5">
                                    <div className=" width-fit-content">
                                        <div className="chart mx-2">
                                            <Chart
                                                options={this.state.options}
                                                series={
                                                    this.state.graphDataValue
                                                        ? [
                                                            series.master,
                                                            series.competent,
                                                            series.learning,
                                                            series.novice,
                                                            series.na,
                                                        ]
                                                        : [0, 0, 0, 0, 0, 100]
                                                }
                                                // series={[0,0,0,0,0,100]}
                                                type="pie"
                                                width="250"
                                                height="250"
                                            />
                                            {/* {
                    series.master === 0 &&
                    series.competent === 0 &&
                    series.learning === 0 &&
                    series.novice === 0 &&
                    series.na === 0 ?
                        <span className="fakechart">No graph data available</span> : <></>
                  } */}
                                        </div>
                                        {/* <div className="display-block legend">
                    <div className="display-flex no-wrap">
                      <div
                        className="square mt-10"
                        style={{
                          backgroundColor: this.state.options.colors[0],
                        }}
                      ></div>{" "}
                      <div className="mt-1 mx-2 min-width-legend"> Master </div>
                      <div>
                        <span className="mx-5 mt-5">
                          {this.state.series.master + "%"}
                        </span>
                      </div>{" "}
                    </div>
                    <div className="display-flex no-wrap">
                      <div
                        className="square mt-10"
                        style={{
                          backgroundColor: this.state.options.colors[1],
                        }}
                      ></div>{" "}
                      <div className="mt-1 mx-2 min-width-legend">
                        Competent{" "}
                      </div>
                      <div>
                        <span className="mx-5 mt-5">
                          {this.state.series.competent + "%"}
                        </span>
                      </div>{" "}
                    </div>
                    <div className="display-flex no-wrap">
                      <div
                        className="square mt-10"
                        style={{
                          backgroundColor: this.state.options.colors[2],
                        }}
                      ></div>{" "}
                      <div className="mt-1 mx-2 min-width-legend">
                        Learner{" "}
                      </div>
                      <div>
                        <span className="mx-5 mt-5">
                          {this.state.series.learning + "%"}
                        </span>
                      </div>{" "}
                    </div>
                    <div className="display-flex no-wrap">
                      <div
                        className="square mt-10"
                        style={{
                          backgroundColor: this.state.options.colors[3],
                        }}
                      ></div>{" "}
                      <div className="mt-1 mx-2 min-width-legend">Novice </div>
                      <div>
                        <span className="mx-5 mt-5">
                          {this.state.series.novice + "%"}
                        </span>
                      </div>{" "}
                    </div>
                    <div className="display-flex no-wrap">
                      <div
                        className="square mt-10"
                        style={{
                          backgroundColor: this.state.options.colors[4],
                        }}
                      ></div>{" "}
                      <div className="mt-1 mx-2 min-width-legend">NA </div>
                      <div>
                        <span className="mx-5 mt-5">
                          {this.state.series.na + "%"}
                        </span>
                      </div>{" "}
                    </div>
                  </div> */}

                                        {/* {this.state.graphDataValue ? ( */}
                                        <>
                                            <div className="display-block legend-overview">
                                                <div className="display-flex no-wrap">
                                                    <div
                                                        className="square mt-10"
                                                        style={{
                                                            backgroundColor: this.state.options.colors[0],
                                                        }}
                                                    ></div>{" "}
                                                    <div className="padding-top4px mx-2 min-width-legend display-flex">
                                                        {" "}
                                                        Master{" "}
                                                        <div className="tooltip">
                                                            <InfoIcon className="info-icon"></InfoIcon>
                                                            <span class="tooltiptext text-12-normal">
                                                                {
                                                                    this.state.series
                                                                        ?.masterProficiencyDescription
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>{" "}
                                                    <span className="mx-5 mt-1">
                                                        {this.state.series.master + "%"}
                                                    </span>
                                                </div>
                                                <div className="display-flex  no-wrap">
                                                    <div
                                                        className="square mt-10"
                                                        style={{
                                                            backgroundColor: this.state.options.colors[1],
                                                        }}
                                                    ></div>{" "}
                                                    <div className="padding-top4px mx-2 min-width-legend display-flex">
                                                        Competent{" "}
                                                        <div className="tooltip">
                                                            <InfoIcon className="info-icon"></InfoIcon>
                                                            <span class="tooltiptext text-12-normal">
                                                                {
                                                                    this.state.series
                                                                        ?.competentProficiencyDescription
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>{" "}
                                                    <span className="mx-5 mt-1">
                                                        {this.state.series.competent + "%"}
                                                    </span>
                                                </div>
                                                <div className="display-flex  no-wrap">
                                                    <div
                                                        className="square mt-10"
                                                        style={{
                                                            backgroundColor: this.state.options.colors[2],
                                                        }}
                                                    ></div>{" "}
                                                    <div className="padding-top4px mx-2 min-width-legend display-flex">
                                                        Learner{" "}
                                                        <div className="tooltip">
                                                            <InfoIcon className="info-icon"></InfoIcon>
                                                            <span class="tooltiptext text-12-normal">
                                                                {
                                                                    this.state.series
                                                                        ?.learningProficiencyDescription
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>{" "}
                                                    <span className="mx-5 mt-1">
                                                        {this.state.series.learning + "%"}
                                                    </span>
                                                </div>
                                                <div className="display-flex  no-wrap">
                                                    <div
                                                        className="square mt-10"
                                                        style={{
                                                            backgroundColor: this.state.options.colors[3],
                                                        }}
                                                    ></div>{" "}
                                                    <div className="padding-top4px mx-2 min-width-legend display-flex">
                                                        Novice{" "}
                                                        <div className="tooltip">
                                                            <InfoIcon className="info-icon"></InfoIcon>
                                                            <span class="tooltiptext text-12-normal">
                                                                {
                                                                    this.state.series
                                                                        ?.noviceProficiencyDescription
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>{" "}
                                                    <span className="mx-5 mt-1">
                                                        {this.state.series.novice + "%"}
                                                    </span>
                                                </div>
                                                {/* <div className="display-flex  no-wrap">
                          <div
                            className="square mt-10"
                            style={{
                              backgroundColor: this.state.options.colors[4],
                            }}
                          ></div>{" "}
                          <div className="padding-top4px mx-2 min-width-legend display-flex">
                            NA{" "}
                            <div className="tooltip">
                              <InfoIcon className="info-icon"></InfoIcon>
                              <span class="tooltiptext tooltip-na text-12-normal">{this.state.series?.naProficiencyDescription}</span>
                            </div>
                          </div>{" "}
                          <span className="mx-5 mt-1">
                            {this.state.series.na + "%"}
                          </span>
                        </div> */}
                                            </div>
                                        </>
                                        {/* // ) : (
                    //   <>
                    //     <div className="display-block legend-team-nodata">
                    //       <div className="display-flex no-wrap">
                    //         <div
                    //           className="square mt-10"
                    //           style={{ backgroundColor: "#D3D3D3" }}
                    //         ></div>{" "}
                    //         <div className="mt-1 mx-2 min-width-legend">
                    //           {" "}
                    //           No records{" "}
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </>
                    // )} */}
                                    </div>
                                    <div
                                        className={` ${isMobile ? "" : ""
                                            } px-4   no-wrap d-flex flex-column gap-2 mt-4 pt-2`}
                                    >
                                        <span className="mt-1">
                                            <span className="text-14-bold">Name -</span>
                                            <span className="text-14-normal-400">
                                                {this.state.employeeName
                                                    ? " " + this.state.employeeName
                                                    : " -"}
                                            </span>
                                        </span>{" "}
                                        <span className="mt-1">
                                            <span className="text-14-bold">Code -</span>
                                            <span className="text-14-normal-400">
                                                {this.state.employeeCode
                                                    ? " " + this.state.employeeCode
                                                    : " -"}
                                            </span>
                                        </span>
                                        <span className="mt-1">
                                            <span className="text-14-bold">Designation -</span>
                                            <span className="text-14-normal-400">
                                                {this.state.designationName
                                                    ? " " + this.state.designationName
                                                    : " -"}
                                            </span>
                                        </span>
                                        {/* <span className="mt-1">
                      <span className="text-14-bold">Committee Role -</span>
                      <span className="text-14-normal-400">
                        {this.state.committeeRoleName
                          ? " " + this.state.committeeRoleName
                          : " -"}
                      </span>
                    </span> */}
                                        {/* </span> */}
                                    </div>
                                </div>
                            </div>
                            {/* <div>
  {this.state.employeeName + " ( " + (this.state.employeeCode ? this.state.employeeCode : "-") + " )"}
</div> */}

                            {/* Tab */}
                            {/* <div
                className={`${
                  this.state.graphDataValue ? "mt-3" : "mt-3"
                } common-table-bottom table-responsive table-responsive-scroll col-12 margin-bottom-table`}
              > */}
                            <div
                                className={`${this.state.graphDataValue ? "mt-3" : "mt-3"
                                    } common-table-bottom table-responsive col-12 margin-bottom-table`}
                            >
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button
                                            class={`active tabsButton cursor-pointer `}
                                            id="MainRoles-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#MainRoles"
                                            type="button"
                                            role="tab"
                                            aria-controls="MainRoles"
                                            aria-selected="true"
                                            onClick={() => {
                                                this.executeWithConfirm(
                                                    this.state.isCommitteeroleChanged,
                                                    this.changeMain,
                                                    "Updated changes are not yet saved, Do you want to continue?"
                                                );
                                            }}
                                        >
                                            <span
                                                className={`${mainRoleBorder
                                                    ? "border-bottom-red padBottom text-danger"
                                                    : ""
                                                    }`}
                                            >
                                                Main roles
                                            </span>
                                        </button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button
                                            class={`tabsButton cursor-pointer`}
                                            id="CommitteeRoles-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#CommitteeRoles"
                                            type="button"
                                            role="tab"
                                            aria-controls="CommitteeRoles"
                                            aria-selected="false"
                                            onClick={() => {
                                                this.executeWithConfirm(
                                                    this.state.isMainRoleChanged,
                                                    this.changeCommittee,
                                                    "Updated changes are not yet saved, Do you want to continue?"
                                                );
                                            }}
                                        >
                                            <span
                                                className={` ${supportroleBorder
                                                    ? "border-bottom-red padBottom text-danger"
                                                    : ""
                                                    }`}
                                            >
                                                Committee roles
                                            </span>
                                        </button>
                                    </li>
                                    <div className="filter-icon filter-icon-position text-align-end">
                                        <span
                                            className="cursor-pointer"
                                            onClick={this.filterMainCommitteeRoles}
                                        >
                                            <CommonIcon fileName="filterIcon" />
                                        </span>
                                    </div>
                                </ul>

                                {/* </div> */}
                                <div class="tab-content" id="myTabContent">
                                    <div
                                        class={`tab-pane fade ${mainRoleBorder ? "show active" : ""
                                            } `}
                                        // id="MainRoles"
                                        // role="tabpanel"
                                        aria-labelledby="MainRoles-tab"
                                    >
                                        {/* <div className="table-responsive table-responsive-scroll"> */}
                                        <div className="table-responsive">
                                            <div className="table-fixed-header height-33vh">
                                                <table className="table fileListTable2  table-borderless">
                                                    <thead>
                                                        <tr>
                                                            <td></td>

                                                            <td
                                                                onClick={() => this.sortTable1("jobGroup")}
                                                                className="cursor-pointer"
                                                            >
                                                                <span> Job group </span>
                                                                {sortBy1 === "jobGroup" && (
                                                                    <CommonIcon
                                                                        className="cursor-pointer"
                                                                        fileName={
                                                                            order1 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                onClick={() => this.sortTable1("jobName")}
                                                                className="cursor-pointer"
                                                            >
                                                                <span> Job/Task </span>
                                                                {sortBy1 === "jobName" && (
                                                                    <CommonIcon
                                                                        className="cursor-pointer"
                                                                        fileName={
                                                                            order1 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>

                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable1("skillName")}
                                                            >
                                                                <span> Skills </span>
                                                                {sortBy1 === "skillName" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order1 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable1("levelName")}
                                                            >
                                                                <span> Level </span>
                                                                {sortBy1 === "levelName" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order1 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() =>
                                                                    this.sortTable1("expectedProficiency")
                                                                }
                                                            >
                                                                <span> Proficiency expected </span>
                                                                {sortBy1 === "expectedProficiency" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order1 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable1("proficiency")}
                                                            >
                                                                <span> Proficiency </span>
                                                                {sortBy1 === "proficiency" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order1 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable1("mastery")}
                                                            >
                                                                <span> Outstanding </span>
                                                                {sortBy1 === "mastery" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order1 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {skillMatrixList.length !== 0 ? (
                                                            skillMatrixList?.map((item, index) => (
                                                                <tr id={"activematrix" + index} key={index}>
                                                                    <td className="cursor-default"></td>
                                                                    <td className="cursor-default min-width-jobtask py-2">
                                                                        <span>{item.jobGroup || "-"}</span>
                                                                    </td>
                                                                    <td className="cursor-default min-width-jobtask py-2">
                                                                        <span>{item.jobName || "-"}</span>
                                                                    </td>
                                                                    <td className="cursor-default min-width-skills">
                                                                        <span>{item.skillName}</span>
                                                                    </td>
                                                                    <td className="cursor-default min-width-skills">
                                                                        <span>{item.levelName}</span>
                                                                    </td>
                                                                    <td className="cursor-default min-width-skills">
                                                                        <span>{item.expectedProficiency}</span>
                                                                    </td>
                                                                    <td className="proficiency-select min-width-skills">
                                                                        {/* <div
                                                                            className="basic-multi-select-team"
                                                                            onClick={this.showDateErrorMessage}
                                                                        >
                                                                            <Select
                                                                                className={`text-12-normal-select my-input-class ${this.state.proficiencyError &&
                                                                                    (item.proficiencyId == 0 ||
                                                                                        item.proficiency == "" ||
                                                                                        item.proficiency == null)
                                                                                    ? "required-field"
                                                                                    : ""
                                                                                    }`}
                                                                                classNamePrefix="assigngroups"
                                                                                menuPosition="fixed"
                                                                                isDisabled={
                                                                                    this.state.isdateValidate == false
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                menuPlacement="auto"
                                                                                value={{
                                                                                    value:
                                                                                        item.proficiencyId +
                                                                                        "," +
                                                                                        item.proficiency,
                                                                                    label: (
                                                                                        <>
                                                                                            <span
                                                                                                className={`${item.proficiencyId == 45 &&
                                                                                                    "green-color"
                                                                                                    } ${item.proficiencyId == 46 &&
                                                                                                    "blue-color"
                                                                                                    } ${item.proficiencyId == 47 &&
                                                                                                    "orange-color"
                                                                                                    } ${item.proficiencyId == 48 &&
                                                                                                    "brown-color"
                                                                                                    } ${item.proficiencyId == 50 &&
                                                                                                    "yellow-color"
                                                                                                    }`}
                                                                                            >
                                                                                                {item.proficiency}
                                                                                            </span>
                                                                                        </>
                                                                                    ),
                                                                                }}
                                                                                options={newColors}
                                                                                defaultValue={[
                                                                                    newColors[1],
                                                                                    newColors[0],
                                                                                ]}
                                                                                isClearable={true}
                                                                                styles={{
                                                                                    menuPortal: (base) => ({
                                                                                        ...base,
                                                                                        zIndex: 9999,
                                                                                        width: "1000px",
                                                                                    }),
                                                                                    ...colorStyles,
                                                                                    ...{
                                                                                        control: (styles) => ({
                                                                                            ...styles,
                                                                                        }),
                                                                                    },
                                                                                }}
                                                                                isMulti={false}
                                                                                isSearchable={false}
                                                                                onChange={(e) =>
                                                                                    this.onchangeProficiecy(
                                                                                        e,
                                                                                        index,
                                                                                        "skillMatrixList"
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div> */}
                                                                        <span
                                                                            className={`${item.proficiencyId == 45 &&
                                                                                "green-color"
                                                                                } ${item.proficiencyId == 46 &&
                                                                                "blue-color"
                                                                                } ${item.proficiencyId == 47 &&
                                                                                "orange-color"
                                                                                } ${item.proficiencyId == 48 &&
                                                                                "brown-color"
                                                                                } ${item.proficiencyId == 50 &&
                                                                                "yellow-color"
                                                                                }`}
                                                                        >
                                                                            {item.proficiency}
                                                                        </span>
                                                                    </td>

                                                                    <td
                                                                        className="cursor-default min-width-skills"
                                                                        id={index}
                                                                    >
                                                                        {this.state.isdateValidate == false ||
                                                                            this.state.isLevelValidate == false ? (
                                                                            <div
                                                                                onClick={
                                                                                    this.state.isdateValidate == false
                                                                                        ? this.showDateErrorMessage
                                                                                        : this.state.isLevelValidate ==
                                                                                            false
                                                                                            ? this.showLevelErrorMessage
                                                                                            : ""
                                                                                }
                                                                            >
                                                                                <StarRatings
                                                                                    rating={0}
                                                                                    numberOfStars={3}
                                                                                    starDimension="13px"
                                                                                    starSpacing="1px"
                                                                                    name="rating"
                                                                                />
                                                                            </div>
                                                                        ) : item.proficiencyId == 45 ||
                                                                            item.proficiencyId == 46 ? (
                                                                            <>
                                                                                <StarRatings
                                                                                    rating={item.mastery}
                                                                                    starRatedColor={"black"}
                                                                                    // starHoverColor={"black"}
                                                                                    // changeRating={(e) => {
                                                                                    //     this.changeRating(
                                                                                    //         e,
                                                                                    //         index,
                                                                                    //         "skillMatrixList"
                                                                                    //     );
                                                                                    // }}
                                                                                    numberOfStars={3}
                                                                                    starDimension="13px"
                                                                                    starSpacing="1px"
                                                                                    name="rating"
                                                                                />
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <StarRatings
                                                                                    rating={0}
                                                                                    // starRatedColor={"black"}
                                                                                    // starHoverColor={"black"}
                                                                                    //   changeRating={(e) => {
                                                                                    //     this.changeRating(
                                                                                    //       e,
                                                                                    //       index,
                                                                                    //       "skillMatrixList"
                                                                                    //     )
                                                                                    // }
                                                                                    //   }
                                                                                    numberOfStars={3}
                                                                                    starDimension="13px"
                                                                                    starSpacing="1px"
                                                                                    name="rating"
                                                                                />
                                                                            </>
                                                                        )}

                                                                        {/* <button className="on"><span className="star">&#9733;</span></button> */}
                                                                    </td>
                                                                </tr>
                                                                //   ${ ( item.proficiency == "competent" || "master" ) ? "green-color" : "yellow-color" }
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={7}>{"No record found"}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="pt-3 mx-3 text-12-normal display-flex">
                                                <div className="mx-2">
                                                    <button
                                                        className="back-button cursor-pointer"
                                                        onClick={() => {
                                                            // this.state.isMainRole = false;
                                                            // this.state.isSupportRole = false;
                                                            // this.state.isSkillMatrix = false;
                                                            // this.state.mainRoleBorder = true;
                                                            // this.state.supportroleBorder = false;
                                                            this.setState({
                                                                isMainRole: false,
                                                                isSupportRole: false,
                                                                isSkillMatrix: false,
                                                                mainRoleBorder: true,
                                                                supportroleBorder: false,
                                                                currentPageMr: 1,
                                                                currentPageCr: 1,
                                                                paginListMainRole: [{ label: "20", value: 20 }],
                                                                pagingListCommitteeRole: [
                                                                    { label: "20", value: 20 },
                                                                ],
                                                                perPageMr: 20,
                                                                perPageCr: 20,
                                                            });
                                                            this.getTeamList(
                                                                this.state.currentPage,
                                                                this.state.perPage
                                                            );
                                                            this.getCapabilitySummary();
                                                        }}
                                                    >
                                                        <CommonIcon fileName="backicon" />
                                                        Back
                                                    </button>
                                                </div>
                                                {/* <div>
                                                    <button
                                                        className={`btn approvebutton ml-10"}`}
                                                        onClick={() => this.UpdateSkillData("main")}
                                                    >
                                                        <CommonIcon fileName="ButtonSubmitApprovalIcon" />
                                                        Submit
                                                    </button>
                                                </div> */}
                                            </div>
                                            <div
                                                className="col-12  title"
                                                style={{ paddingLeft: "15px" }}
                                            >
                                                <span className="pl-10 head-span">Audit Log</span>
                                            </div>
                                            <div className="table-responsive">
                                                <div className="table-fixed-header height-33vh">
                                                    <table className="table fileListTable2 table-borderless">
                                                        <thead>
                                                            <tr>
                                                                <td></td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Job group</span>
                                                                </td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Job/Task</span>
                                                                </td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Action</span>
                                                                </td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Action by</span>
                                                                </td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Date</span>
                                                                </td>
                                                            </tr>
                                                        </thead>

                                                        {auditLog && auditLog.length != 0 ? (
                                                            <tbody>
                                                                {auditLog.map((element, index) => (
                                                                    <tr>
                                                                        <td></td>
                                                                        <td>
                                                                            <span>
                                                                                {element.jobGroup
                                                                                    ? element.jobGroup
                                                                                    : "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>
                                                                                {element.jobName
                                                                                    ? element.jobName
                                                                                    : "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>
                                                                                {element.action ? element.action : "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>
                                                                                {element.actionBy
                                                                                    ? element.actionBy
                                                                                    : "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>
                                                                                {element.date
                                                                                    ? this.convertTimestamp(element.date)
                                                                                    : "-"}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        ) : (
                                                            <>
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan={5}>
                                                                            <span>No record found</span>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </>
                                                        )}
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class={`tab-pane fade ${supportroleBorder ? "show active" : ""
                                            } `}
                                        // id="CommitteeRoles"
                                        // role="tabpanel"
                                        aria-labelledby="CommitteeRoles-tab"
                                    >
                                        <div className="table-responsive">
                                            {/* <div className="table-responsive table-responsive-scroll"> */}
                                            {/* <div className={`px-4 pt-20 pb-20 text-20-bold `}>
                        Committee roles
                      </div> */}
                                            <div className="table-fixed-header height-33vh">
                                                <table className="table fileListTable2 table-borderless ">
                                                    <thead>
                                                        <tr>
                                                            <td></td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable2("jobGroup")}
                                                            >
                                                                <span> Job group </span>
                                                                {sortBy2 === "jobGroup" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order2 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable2("jobName")}
                                                            >
                                                                <span> Job/Task </span>
                                                                {sortBy2 === "jobName" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order2 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>

                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable2("skillName")}
                                                            >
                                                                <span> Skills </span>
                                                                {sortBy2 === "skillName" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order2 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable2("levelName")}
                                                            >
                                                                <span> Level </span>
                                                                {sortBy2 === "levelName" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order2 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() =>
                                                                    this.sortTable2("expectedProficiency")
                                                                }
                                                            >
                                                                <span> Proficiency expected </span>
                                                                {sortBy2 === "expectedProficiency" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order2 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable2("proficiency")}
                                                            >
                                                                <span> Proficiency </span>
                                                                {sortBy2 === "proficiency" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order2 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cursor-pointer"
                                                                onClick={() => this.sortTable2("mastery")}
                                                            >
                                                                <span> Outstanding </span>
                                                                {sortBy2 === "mastery" && (
                                                                    <CommonIcon
                                                                        fileName={
                                                                            order2 === "asc" ? "upArrow" : "downArrow"
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            {/* <td></td> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {supportingRolesList?.length !== 0 ? (
                                                            supportingRolesList?.map((item, index) => (
                                                                <tr id={"activerole" + index} key={index}>
                                                                    <td className="cursor-default"></td>
                                                                    <td className="cursor-default min-width-jobtask py-2">
                                                                        <span>{item.jobGroup}</span>
                                                                    </td>
                                                                    <td className="cursor-default min-width-jobtask py-2">
                                                                        <span>{item.jobName}</span>
                                                                    </td>
                                                                    <td className="cursor-default min-width-skills">
                                                                        <span>{item.skillName}</span>
                                                                    </td>
                                                                    <td className="cursor-default min-width-skills">
                                                                        <span>{item.levelName}</span>
                                                                    </td>
                                                                    <td className="cursor-default min-width-skills">
                                                                        <span>{item.expectedProficiency}</span>
                                                                    </td>
                                                                    <td className="min-width-skills">
                                                                        {/* <div
                                                                            className="basic-multi-select-team"
                                                                            onClick={this.showDateErrorMessage}
                                                                        >
                                                                            <Select
                                                                                className={`text-12-normal-select my-input-class ${this.state.proficiencyError &&
                                                                                    (item.proficiencyId == 0 ||
                                                                                        item.proficiency == "" ||
                                                                                        item.proficiency == null)
                                                                                    ? "required-field"
                                                                                    : ""
                                                                                    }`}
                                                                                classNamePrefix="assigngroups"
                                                                                placeholder="Select"
                                                                                menuPosition="fixed"
                                                                                menuPlacement="auto"
                                                                                isDisabled={
                                                                                    this.state.isdateValidate == false
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                value={{
                                                                                    value:
                                                                                        item.proficiencyId +
                                                                                        "," +
                                                                                        item.proficiency,
                                                                                    label: (
                                                                                        <>
                                                                                            <span
                                                                                                className={`${item.proficiencyId == 45 &&
                                                                                                    "green-color"
                                                                                                    } ${item.proficiencyId == 46 &&
                                                                                                    "blue-color"
                                                                                                    } ${item.proficiencyId == 47 &&
                                                                                                    "orange-color"
                                                                                                    } ${item.proficiencyId == 48 &&
                                                                                                    "brown-color"
                                                                                                    } ${item.proficiencyId == 50 &&
                                                                                                    "yellow-color"
                                                                                                    }`}
                                                                                            >
                                                                                                {item.proficiency}
                                                                                            </span>
                                                                                        </>
                                                                                    ),
                                                                                }}
                                                                                options={newColors}
                                                                                defaultValue={[
                                                                                    newColors[1],
                                                                                    newColors[0],
                                                                                ]}
                                                                                styles={{
                                                                                    menuPortal: (base) => ({
                                                                                        ...base,
                                                                                        zIndex: 9999,
                                                                                        width: "1000px",
                                                                                    }),
                                                                                    ...colorStyles,
                                                                                    ...{
                                                                                        control: (styles) => ({
                                                                                            ...styles,
                                                                                        }),
                                                                                    },
                                                                                }}
                                                                                isClearable={true}
                                                                                isMulti={false}
                                                                                isSearchable={false}
                                                                                onChange={(e) =>
                                                                                    this.onchangeProficiecy(
                                                                                        e,
                                                                                        index,
                                                                                        "supportingRolesList"
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div> */}
                                                                        <span
                                                                            className={`${item.proficiencyId == 45 &&
                                                                                "green-color"
                                                                                } ${item.proficiencyId == 46 &&
                                                                                "blue-color"
                                                                                } ${item.proficiencyId == 47 &&
                                                                                "orange-color"
                                                                                } ${item.proficiencyId == 48 &&
                                                                                "brown-color"
                                                                                } ${item.proficiencyId == 50 &&
                                                                                "yellow-color"
                                                                                }`}
                                                                        >
                                                                            {item.proficiency}
                                                                        </span>
                                                                    </td>
                                                                    <td className="cursor-default min-width-skills">
                                                                        {this.state.isdateValidate == false ||
                                                                            this.state.isLevelValidate == false ? (
                                                                            <div
                                                                                onClick={
                                                                                    this.state.isdateValidate == false
                                                                                        ? this.showDateErrorMessage
                                                                                        : this.state.isLevelValidate ==
                                                                                            false
                                                                                            ? this.showLevelErrorMessage
                                                                                            : ""
                                                                                }
                                                                            >
                                                                                <StarRatings
                                                                                    rating={0}
                                                                                    numberOfStars={3}
                                                                                    starDimension="13px"
                                                                                    starSpacing="1px"
                                                                                    name="rating"
                                                                                />
                                                                            </div>
                                                                        ) : item.proficiencyId == 45 ||
                                                                            item.proficiencyId == 46 ? (
                                                                            <>
                                                                                <StarRatings
                                                                                    rating={item.mastery}
                                                                                    starRatedColor={"black"}
                                                                                    // starHoverColor={"black"}
                                                                                    // changeRating={(e) => {
                                                                                    //     this.changeRating(
                                                                                    //         e,
                                                                                    //         index,
                                                                                    //         "supportingRolesList"
                                                                                    //     );
                                                                                    // }}
                                                                                    numberOfStars={3}
                                                                                    starDimension="13px"
                                                                                    starSpacing="1px"
                                                                                    name="rating"
                                                                                />
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <StarRatings
                                                                                    rating={0}
                                                                                    // starRatedColor={"black"}
                                                                                    // starHoverColor={"black"}
                                                                                    //   changeRating={(e) => {
                                                                                    //     this.changeRating(
                                                                                    //       e,
                                                                                    //       index,
                                                                                    //       "skillMatrixList"
                                                                                    //     )
                                                                                    // }
                                                                                    //   }
                                                                                    numberOfStars={3}
                                                                                    starDimension="13px"
                                                                                    starSpacing="1px"
                                                                                    name="rating"
                                                                                />
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    {/* <td className="cursor-default"></td> */}
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={7}>{"No record found"}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="pt-3 mx-3 text-12-normal display-flex">
                                                <div className="mx-2">
                                                    <button
                                                        className="back-button cursor-pointer"
                                                        onClick={() => {
                                                            this.setState({
                                                                isSkillMatrix: false,
                                                                mainRoleBorder: true,
                                                                supportroleBorder: false,
                                                                employeeCode: "",
                                                                employeeName: "",
                                                                currentPageMr: 1,
                                                                currentPageCr: 1,
                                                                paginListMainRole: [{ label: "20", value: 20 }],
                                                                pagingListCommitteeRole: [
                                                                    { label: "20", value: 20 },
                                                                ],
                                                                perPageMr: 20,
                                                                perPageCr: 20,
                                                            });
                                                            this.getTeamList(
                                                                this.state.currentPage,
                                                                this.state.perPage
                                                            );
                                                            this.getCapabilitySummary();
                                                        }}
                                                    >
                                                        <CommonIcon fileName="backicon" />
                                                        Back
                                                    </button>
                                                </div>
                                                {/* <div>
                                                    <button
                                                        className={`btn approvebutton ml-10"}`}
                                                        onClick={() => this.UpdateSkillData("committee")}
                                                    >
                                                        <CommonIcon fileName="ButtonSubmitApprovalIcon" />
                                                        Submit
                                                    </button>
                                                </div> */}
                                            </div>
                                            <div
                                                className="col-12  title"
                                                style={{ paddingLeft: "15px" }}
                                            >
                                                <span className="pl-10 head-span">Audit Log</span>
                                            </div>
                                            <div className="table-responsive">
                                                <div className="table-fixed-header height-33vh">
                                                    <table className="table fileListTable2 table-borderless">
                                                        <thead>
                                                            <tr>
                                                                <td></td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Job group</span>
                                                                </td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Job/Task</span>
                                                                </td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Action</span>
                                                                </td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Action by</span>
                                                                </td>
                                                                <td className="cursor-pointer" width={"20%"}>
                                                                    <span>Date</span>
                                                                </td>
                                                            </tr>
                                                        </thead>
                                                        {auditLog && auditLog.length != 0 ? (
                                                            <tbody>
                                                                {auditLog.map((element, index) => (
                                                                    <tr>
                                                                        <td></td>
                                                                        <td>
                                                                            <span>
                                                                                {element.jobGroup
                                                                                    ? element.jobGroup
                                                                                    : "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>
                                                                                {element.jobName
                                                                                    ? element.jobName
                                                                                    : "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>
                                                                                {element.action ? element.action : "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>
                                                                                {element.actionBy
                                                                                    ? element.actionBy
                                                                                    : "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>
                                                                                {element.date
                                                                                    ? this.convertTimestamp(element.date)
                                                                                    : "-"}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        ) : (
                                                            <>
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan={5}>
                                                                            <span>No record found</span>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </>
                                                        )}
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* End Tabs */}

                            {/* End New SkillChart */}
                        </>
                    )}

                    <div
                        className={`offcanvas offcanvas-end offcanvasStyle ${this.state.searchScreen ? "show" : ""
                            }`}
                        tabIndex={-1}
                        data-bs-scroll="false"
                        data-bs-backdrop="false"
                        id="searchScreen"
                        aria-labelledby="offcanvasScrollingLabel"
                    >
                        <div
                            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"
                                }`}
                        >
                            <h6 id="offcanvasRightLabel" className="modal-title">
                                Search
                            </h6>
                            <button
                                className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : "pr-0"
                                    }`}
                                onClick={() => {
                                    $("#searchScreen").removeClass("show");
                                    this.setState({ validationMsg: false, searchScreen: false });
                                    $("body").removeClass("scrollhide");
                                }}
                            >
                                <CommonIcon fileName="CrossIcon" />
                            </button>
                        </div>
                        <div className="offcanvas-body px-4 pt-0">
                            <div className="row">
                                <div
                                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
                                >
                                    <div className="form-group">
                                        <div className="row">
                                            <div
                                                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                                                    }`}
                                            >
                                                <div className="form-group">
                                                    <label
                                                        className={`d-flex m-0 label-text pb-1 ${isMobile ? "pt-2" : ""
                                                            }`}
                                                    >
                                                        <CommonIcon
                                                            className="properties-img-2"
                                                            fileName="employeecode"
                                                        />
                                                        <span className="pl-5 properties-span-2">
                                                            Employee code
                                                        </span>
                                                        &nbsp;
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-text-box my-input-class searchInputs input-box-masterdata"
                                                        id="employeeCode"
                                                        value={this.state.searchInputData.employeeCode}
                                                        onChange={(e) =>
                                                            this.handleInputchange(e, "employeeCode")
                                                        }
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                                                <label
                                                    className={`label-text  ${isMobile
                                                        ? "d-flex pt-2 mb-2-ledger"
                                                        : "d-flex mb-2-ledger mb-1"
                                                        }`}
                                                >
                                                    <CommonIcon
                                                        className="properties-img-2"
                                                        fileName="UserIcon"
                                                    />
                                                    <span className="pl-5 properties-search-span">
                                                        Employee name
                                                    </span>
                                                </label>
                                                <Select
                                                    className={` text-12-normal-select my-input-class `}
                                                    // className={` text-12-normal my-input-class  ${isSkillEmpty && 'border-red'}  `}
                                                    classNamePrefix="assigngroups"
                                                    value={this.state.selectEmployeeName}
                                                    options={this.state.employeeList}
                                                    defaultValue={"Select"}
                                                    placeholder="Select"
                                                    isClearable={true}
                                                    menuPosition="fixed"
                                                    menuPlacement="auto"
                                                    isMulti={false}
                                                    isSearchable={true}
                                                    onChange={this.onchangeEmployeeName}
                                                />
                                            </div>
                                            <div
                                                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                                                    }`}
                                            >
                                                <div className="form-group">
                                                    <label
                                                        className={`d-flex m-0 label-text pb-1 ${isMobile ? "pt-2" : ""
                                                            }`}
                                                    >
                                                        <CommonIcon
                                                            className="properties-img-2"
                                                            fileName="courseDescIcon"
                                                        />
                                                        <span className="pl-5 properties-span-2">
                                                            Designation
                                                        </span>
                                                        &nbsp;
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-text-box my-input-class searchInputs input-box-masterdata"
                                                        id="designation"
                                                        value={this.state.searchInputData.designation}
                                                        onChange={(e) =>
                                                            this.handleInputchange(e, "designation")
                                                        }
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            {/* <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                          isMobile ? "" : "pb-3"
                        }`}
                      >
                        <div className="form-group">
                          <label
                            className={`d-flex m-0 label-text pb-1 ${
                              isMobile ? "pt-2" : ""
                            }`}
                          >
                            <CommonIcon
                              className="properties-img-2"
                              fileName="VendorEmail"
                            />
                            <span className="pl-5 properties-span-2">
                              Email
                            </span>
                            &nbsp;
                          </label>
                          <input
                            type="text"
                            className="form-control form-text-box my-input-class searchInputs input-box-masterdata"
                            id="email"
                            value={this.state.searchInputData.email}
                            onChange={(e) => this.handleInputchange(e, "email")}
                            required
                          />
                        </div>
                      </div>
                      <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                          isMobile ? "" : "pb-3"
                        }`}
                      >
                        <div className="form-group">
                          <label
                            className={`d-flex m-0 label-text pb-1 ${
                              isMobile ? "pt-2" : ""
                            }`}
                          >
                            <CommonIcon
                              className="properties-img-2"
                              fileName="ContactNumberIcon"
                            />
                            <span className="pl-5 properties-span-2">
                              Phone number
                            </span>
                            &nbsp;
                          </label>
                          <input
                            type="text"
                            className="form-control form-text-box my-input-class searchInputs input-box-masterdata"
                            id="phoneNumber"
                            value={this.state.searchInputData.phoneNumber}
                            onChange={(e) =>
                              this.handleInputchange(e, "phoneNumber")
                            }
                            required
                          />
                        </div>
                      </div> */}
                                            <div
                                                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                                                    }`}
                                            >
                                                <div className="form-group">
                                                    <label
                                                        className={`d-flex m-0 label-text pb-1 ${isMobile ? "pt-2" : ""
                                                            }`}
                                                    >
                                                        <CommonIcon
                                                            className="properties-img-2"
                                                            fileName="statusIcon"
                                                        />
                                                        <span className="pl-5 properties-span-2">
                                                            Status
                                                        </span>
                                                        &nbsp;
                                                    </label>
                                                    <Select
                                                        className={` text-12-normal-select my-input-class `}
                                                        // className={` text-12-normal my-input-class  ${isSkillEmpty && 'border-red'}  `}
                                                        classNamePrefix="assigngroups"
                                                        value={this.state.selectedStatus}
                                                        options={this.state.currentStatus}
                                                        defaultValue={"Select"}
                                                        placeholder="Select"
                                                        isClearable={true}
                                                        menuPosition="fixed"
                                                        menuPlacement="auto"
                                                        isMulti={false}
                                                        isSearchable={true}
                                                        onChange={(e) => this.onchangeStatus(e, "status")}
                                                    />
                                                </div>
                                            </div>

                                            {localStorage
                                                .getItem("Role")
                                                .split(",")
                                                .includes("manager") && (
                                                    <div
                                                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                                                            }`}
                                                    >
                                                        <div className="form-group">
                                                            <label
                                                                className={`d-flex m-0 label-text pb-1 ${isMobile ? "pt-2" : ""
                                                                    }`}
                                                            >
                                                                <CommonIcon
                                                                    className="properties-img-2"
                                                                    fileName="supervisorIcon"
                                                                />
                                                                <span className="pl-5 properties-span-2">
                                                                    Supervisor
                                                                </span>
                                                                &nbsp;
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control form-text-box my-input-class searchInputs input-box-masterdata"
                                                                id="phoneNumber"
                                                                value={this.state.searchInputData.supervisor}
                                                                onChange={(e) =>
                                                                    this.handleInputchange(e, "supervisor")
                                                                }
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            <div
                                                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                                                    }`}
                                            >
                                                <div className="form-group ">
                                                    <label
                                                        className={`d-flex m-0 align-items-center label-text pb-1 ${isMobile ? "pt-2" : ""
                                                            }`}
                                                    >
                                                        <CommonIcon
                                                            className="properties-img-3"
                                                            fileName="departmentIcon"
                                                        />
                                                        <span className="pl-5 properties-span-2">
                                                            Department
                                                        </span>
                                                        &nbsp;
                                                    </label>
                                                    <Select
                                                        className={`text-12-normal-select my-input-class`}
                                                        classNamePrefix="assigngroups"
                                                        placeholder="Select department"
                                                        value={this.state.searchInputData.department}
                                                        onChange={(e) =>
                                                            this.handleInputchange({
                                                                target: {
                                                                    value: e
                                                                }
                                                            }, "department")
                                                        }
                                                        options={this.state.departmentNameList}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.validationMsg ? (
                                <span className="properties-span-2 text-danger">
                                    Atleast one field is mandatory
                                </span>
                            ) : (
                                ""
                            )}
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                                <div className="d-flex mt-20">
                                    <button
                                        className={`btn rejectbutton d-flex gap-1`}
                                        onClick={() => this.clearSearchFields()}
                                    >
                                        <span className="mt-0">
                                            <CommonIcon fileName="clearIcon1" />
                                        </span>
                                        <span className="pl-vendor3 pl-2">Clear</span>
                                    </button>
                                    <button
                                        className={`btn approvebutton ml-10 d-flex gap-1`}
                                        onClick={() => this.searchSupportRoleList()}
                                    >
                                        <span className="">
                                            <CommonIcon fileName="searchableIcon" />
                                        </span>
                                        <span className="model-label pl-vendor3 pl-2">Search</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className={`offcanvas offcanvas-end offcanvasStyle ${this.state.searchScreen1 ? "show" : ""
                            } `}
                        tabIndex={-1}
                        data-bs-scroll="false"
                        data-bs-backdrop="false"
                        id="searchScreen1"
                        aria-labelledby="offcanvasScrollingLabel"
                    // style={{ display: this.state.searchScreen1 ? "block" : "none" }}
                    >
                        <div
                            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-0" : "pb-0"
                                }`}
                        >
                            <h6 id="offcanvasRightLabel" className="modal-title">
                                Search
                            </h6>
                            <button
                                className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : "pr-0"
                                    }`}
                                onClick={() => {
                                    {
                                        $("#searchScreen1").removeClass("show");
                                        this.setState({ searchScreen1: false });
                                    }
                                }}
                            >
                                <CommonIcon fileName="CrossIcon" />
                            </button>
                        </div>
                        <div className="offcanvas-body px-4 pt-0 h-100">
                            <div className="row g-0">
                                <div
                                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
                                >
                                    <div className="form-group">
                                        <div className="row">
                                            <div
                                                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-6 mt-2 h-full ${isMobile ? "" : "pb-0"
                                                    }`}
                                            >
                                                <div className="form-group">
                                                    <label
                                                        className={`d-flex m-0 label-text pb-1 ${isMobile ? "pt-2" : ""
                                                            }`}
                                                    >
                                                        <CommonIcon
                                                            className="properties-img-2"
                                                            fileName="employeecode"
                                                        />
                                                        <span className="pl-5 properties-span-2">
                                                            Proficiency
                                                        </span>
                                                        &nbsp;
                                                    </label>
                                                    <Select
                                                        className={`text-12-normal-select my-input-class`}
                                                        classNamePrefix="assigngroups"
                                                        value={this.state.selectedProficiencyId}
                                                        options={this.state.proficiencyList}
                                                        menuPosition="fixed"
                                                        isMulti={true}
                                                        onChange={(selectedOptions) => {
                                                            this.setState({
                                                                selectedProficiencyId: selectedOptions || [],
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group mt-2">
                                                    <label
                                                        className={`d-flex m-0 align-items-center label-text pb-1 ${isMobile ? "pt-2" : ""
                                                            }`}
                                                    >
                                                        <CommonIcon
                                                            className="properties-img-3"
                                                            fileName="departmentIcon"
                                                        />
                                                        <span className="pl-5 properties-span-2">
                                                            Department
                                                        </span>
                                                        &nbsp;
                                                    </label>
                                                    <Select
                                                        className={`text-12-normal-select my-input-class`}
                                                        classNamePrefix="assigngroups"
                                                        placeholder="Select department"
                                                        value={this.state.selectedDepartmentId}
                                                        onChange={(e) => {
                                                            this.setState({ selectedDepartmentId: e });
                                                        }}
                                                        options={this.state.departmentNameList}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.validationMsg ? (
                                <span className="properties-span-2 text-danger">
                                    Department is mandatory
                                </span>
                            ) : (
                                ""
                            )}
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-1 mt-2">
                                <div className="d-flex">
                                    <button
                                        className={`btn rejectbutton d-flex gap-1`}
                                        type="button"
                                        onClick={(e) => this.clearSearchCapabilitySummaryFields(e)}
                                    >
                                        <span className="mt-0">
                                            <CommonIcon fileName="clearIcon1" />
                                        </span>
                                        <span className="pl-vendor3 pl-2">Clear</span>
                                    </button>
                                    <button
                                        className={`btn approvebutton ml-10 d-flex gap-1`}
                                        type="button"
                                        onClick={(e) => this.searchCapabilitysummary(e)}
                                    >
                                        <span className="">
                                            <CommonIcon fileName="searchableIcon" />
                                        </span>
                                        <span className="model-label pl-vendor3 pl-2">Search</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* {!isSkillMatrix && (
          <PaginationComponent
            fetchPagination={this.fetchPaginationList}
            pageCount={this.state.totalCount}
            reset={this.state.pageNewCount}
          />
        )} */}

                {(this.state.isSkillMatrix == false
                    ? this.state.pageCount > 0
                    : this.state.mainRoleBorder
                        ? this.state.mainRoleCount > 0
                        : this.state.supportRoleCount > 0) && (
                        <>
                            {!isCapabilitySummary && (
                                <div
                                    className={`${isMobile
                                        ? "common-mobilesubmenu mobile-pagination"
                                        : menuToggle
                                            ? "common-submenu sidemenu-pagination"
                                            : "common-submenu web-pagination"
                                        } pb-2 pt-2`}
                                >
                                    <table width="100%">
                                        <tbody>
                                            <tr>
                                                <td width="8%" className="p-3">
                                                    <div
                                                        id="perPage"
                                                        className={`${isMobile450 ? "mobilePageSelect" : "webpageSelect"
                                                            }`}
                                                    >
                                                        <Select
                                                            options={paginglist}
                                                            defaultValue={paginglistDefault}
                                                            placeholder="Select"
                                                            value={
                                                                this.state.isSkillMatrix === false
                                                                    ? this.state.pagingListValue
                                                                    : this.state.mainRoleBorder
                                                                        ? this.state.paginListMainRole
                                                                        : this.state.pagingListCommitteeRole
                                                            }
                                                            classNamePrefix="paging"
                                                            isSearchable={false}
                                                            menuPlacement={"top"}
                                                            menuPosition={"fixed"}
                                                            onChange={(e) => this.find(e)}
                                                        />
                                                    </div>
                                                </td>

                                                <td width="92%" className="text-end p-3">
                                                    {isMobile ? (
                                                        <Pagination
                                                            prevPageText={
                                                                <>
                                                                    <CommonIcon fileName="LeftArrowIcon" />{" "}
                                                                </>
                                                            }
                                                            nextPageText={
                                                                <>
                                                                    <CommonIcon fileName="RightArrowIcon" />
                                                                </>
                                                            }
                                                            linkClassNext="nextArrow"
                                                            linkClassPrev="prevArrow"
                                                            itemClass={`page-item page-width-mobile`}
                                                            linkClass="page-link"
                                                            pageRangeDisplayed={1}
                                                            onChange={(e) => this.handlePageChange(e)}
                                                            activePage={
                                                                this.state.isSkillMatrix === false
                                                                    ? this.state.currentPage
                                                                    : this.state.mainRoleBorder
                                                                        ? this.state.currentPageMr
                                                                        : this.state.currentPageCr
                                                            }
                                                            totalItemsCount={
                                                                this.state.isSkillMatrix === false
                                                                    ? this.state.pageCount
                                                                    : this.state.mainRoleBorder
                                                                        ? this.state.mainRoleCount
                                                                        : this.state.supportRoleCount
                                                            }
                                                            itemsCountPerPage={
                                                                this.state.isSkillMatrix === false
                                                                    ? this.state.perPage
                                                                    : this.state.mainRoleBorder
                                                                        ? this.state.perPageMr
                                                                        : this.state.perPageCr
                                                            }
                                                        />
                                                    ) : (
                                                        <Pagination
                                                            prevPageText={
                                                                <>
                                                                    <CommonIcon fileName="LeftArrowIcon" />{" "}
                                                                </>
                                                            }
                                                            nextPageText={
                                                                <>
                                                                    <CommonIcon fileName="RightArrowIcon" />
                                                                </>
                                                            }
                                                            linkClassNext="nextArrow"
                                                            linkClassPrev="prevArrow"
                                                            itemClass={`page-item page-width`}
                                                            linkClass="page-link"
                                                            pageRangeDisplayed={4}
                                                            onChange={(e) => this.handlePageChange(e)}
                                                            activePage={
                                                                this.state.isSkillMatrix === false
                                                                    ? this.state.currentPage
                                                                    : this.state.mainRoleBorder
                                                                        ? this.state.currentPageMr
                                                                        : this.state.currentPageCr
                                                            }
                                                            totalItemsCount={
                                                                this.state.isSkillMatrix === false
                                                                    ? this.state.pageCount
                                                                    : this.state.mainRoleBorder
                                                                        ? this.state.mainRoleCount
                                                                        : this.state.supportRoleCount
                                                            }
                                                            itemsCountPerPage={
                                                                this.state.isSkillMatrix === false
                                                                    ? this.state.perPage
                                                                    : this.state.mainRoleBorder
                                                                        ? this.state.perPageMr
                                                                        : this.state.perPageCr
                                                            }
                                                        />
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </>
                    )}
                <CommonFilterModal
                    isMobile={this.state.isMobile}
                    searchFilterData={(obj) => this.searchFilterData(obj)}
                    isMainRole={this.state.isMainRole}
                    clearFilterData={(obj) => this.clearFilterData(obj)}
                    clearFilterData1={(obj) => this.clearFilterData1(obj)}
                />
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompetencyGrading);
